/**
to circumvent Safari bug reported here: https://bugs.webkit.org/show_bug.cgi?id=74193
 */
function _safari_patch(klass) {
   if (typeof klass !== 'function'){
        var temp = function(){};
        temp.prototype = klass.prototype;
        return temp;
    }
    return klass
}

HTMLElement = _safari_patch(HTMLElement);
HTMLInputElement = _safari_patch(HTMLInputElement);
HTMLSelectElement = _safari_patch(HTMLSelectElement);
HTMLFormElement = _safari_patch(HTMLFormElement);
HTMLAnchorElement = _safari_patch(HTMLAnchorElement);
SVGElement = _safari_patch(SVGElement);

const u = {};
u.BaseElement = class extends HTMLElement {
    /**
     * BaseElement for Unity web components
     */
    createdCallback() {}
    attachedCallback() {}
    detachedCallback() {}
    attributeChangedCallback(attr, oldVal, newVal) {}
    static register(tag) {
        document.registerElement(tag, {
            prototype: this.prototype
        });
    }
};

u.BaseInput = class extends HTMLInputElement {
    /**
     * BaseElement for Unity input web components
     */
    createdCallback() {}
    attachedCallback() {}
    detachedCallback() {}
    attributeChangedCallback(attr, oldVal, newVal) {}
    static register(tag) {
        document.registerElement(tag, {
            prototype: this.prototype,
            extends: 'input'
        });
    }
};

u.BaseSelect = class extends HTMLSelectElement {
    /**
     * BaseElement for Unity select web components
     */
    createdCallback() {}
    attachedCallback() {}
    detachedCallback() {}
    attributeChangedCallback(attr, oldVal, newVal) {}
    static register(tag) {
        document.registerElement(tag, {
            prototype: this.prototype,
            extends: 'select'
        });
    }
};

u.BaseForm = class extends HTMLFormElement {
    /**
     * BaseElement for Unity form web components
     */
    createdCallback() {}
    attachedCallback() {}
    detachedCallback() {}
    attributeChangedCallback(attr, oldVal, newVal) {}
    static register(tag) {
        document.registerElement(tag, {
            prototype: this.prototype,
            extends: 'form'
        });
    }
};

u.AnchorElement = class extends HTMLAnchorElement {
    /**
     * AnchorElement for Unity anchor web components
     */
    createdCallback() {}
    attachedCallback() {}
    detachedCallback() {}
    attributeChangedCallback(attr, oldVal, newVal) {}
    static register(tag) {
        document.registerElement(tag, {
            prototype: this.prototype,
            extends: 'a'
        });
    }
};
u.Storage = class extends u.BaseElement {
    /**
     * Simple storage engine with callback capabilities.
     * I'd LOVE to use ES6 proxies for this, but the current polyfill has some limitations.
     * https://github.com/GoogleChrome/proxy-polyfill
     */
    attachedCallback() {
        /**
         * 
         */
        super.attachedCallback();
        this._sep = '|';
        this._listeners = {};
        this._storage = {};
    }

    $listen(path, fn) {
        /**
         * Adds callback
         */
        if (this._listeners[path] === undefined) {
            this._listeners[path] = new Set();
        }
        this._listeners[path].add(fn);
    }

    $ignore(path, fn) {
        /**
         * Removes callback
         */
        if (this._listeners[path] !== undefined) {
            this._listeners[path].delete(fn);
        }
    }

    $set(path, value) {
        /**
         * Set value by path
         */
        // set storage
        const [obj, key] = this._pathPair(path);
        obj[key] = value;
        this.$broadcast(path);
    }

    $broadcast(path) {
        // callback listeners
        const keys = path.split(this._sep);
        for (let i = 1; i <= keys.length; i++) {
            let path = keys.slice(0, i).join(this._sep);
            if (this._listeners[path]) {
                let [obj, key] = this._pathPair(path);
                this._listeners[path].forEach(function (fn) {
                    fn(obj[key]);
                });
            }
        }
    }

    $unset(path) {
        const [obj, key] = this._pathPair(path);
        delete obj[key];
        this.$broadcast(path);
    }

    $get(path) {
        /**
         * Get value by path.
         */
        const [obj, key] = this._pathPair(path);
        return obj[key];
    }

    _pathPair(path) {
        /**
         * Get obj/key pair from path.
         */
        const keys = path.split(this._sep);
        let parent = this._storage;
        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            if (i === keys.length - 1) {
                return [parent, key];
            } else {
                parent = parent[key];
                if (parent === undefined) {
                    throw `Path "${path}" does not exist`;
                }
            }
        }
    }
};

u.Consumer = class extends u.BaseElement {
    attachedCallback() {
        super.attachedCallback();
        this.$storage = null;

        let elem = this.parentElement;
        while (elem) {

            if (elem instanceof u.Storage) {
                this.$storage = elem;
            }
            elem = elem.parentElement;
        }

        if (!this.$storage) {
            throw 'No parent storage element was found';
        }
    };
};

u.ConsumerInput = class extends u.BaseInput {
    attachedCallback() {
        u.Consumer.prototype.attachedCallback.apply(this);
    }
};


u.ConsumerSelect = class extends u.BaseSelect {
    attachedCallback() {
        u.Consumer.prototype.attachedCallback.apply(this);
    }
};


u.Bind = class extends u.Consumer {
    /**
     *
     */
    attachedCallback() {
        /**
         *
         */
        super.attachedCallback();
        this.bindTo = this.getAttribute('bind-to');
        this.$storage.$listen(this.bindTo, this.$onChange.bind(this));
    }

    $onChange(value) {
        /**
         * 
         */
        this.textContent = value;
    }
};

u.Bind.register('u-bind');

u.ForElement = class extends u.BaseElement {
    /**
     * 
     */
    createdCallback() {
        /**
         * Set defaults
         */
        super.createdCallback();
        this.$forElement = null;
    }
        
    attachedCallback() {
        /**
         * 
         */
        super.attachedCallback();
        const id = this.getAttribute('u-for');
        this.$forElement = document.getElementById(id);
        if (this.$forElement === null) {
            throw `Element ${id} was not found`;
        }
    }
};

u.Toggle = class extends u.ForElement {
    /**
     *
     */
    attachedCallback() {
        /**
         *
         */
        super.attachedCallback();
        this.addEventListener('click', (evt) => {
            /**
             * The super.$open method adds a click listener to document, so stopPropagation is required to keep 
             * that callback from overriding this event. 
             */            
            evt.stopPropagation();
            evt.preventDefault();
            this.$forElement.$toggle();
        });
    }
};
u.Toggle.register('u-toggle');

u.Carousel = class extends u.BaseElement {
    /**
     * 
     */    
    createdCallback() {
        /**
         * 
         */
        super.createdCallback();
        this._index = 0;
        this._container = this.firstElementChild;
        this._startIndex = parseInt(this.getAttribute('start-index')) || 0;
        this._numOfChildren = this._container.childElementCount;
    }

    $moveTo(query) {
        /**
         *
         */
        
        // this code calculates the total number of items per page based on the client width of an item and the container
        const itemsPerPage = Math.floor(this._container.clientWidth / this._container.firstElementChild.clientWidth);

        if (query.startsWith('+')) {
            this._index += parseInt(query.substr(1));
        } else if (query.startsWith('-')) {
            this._index -= parseInt(query.substr(1));
        } else {
            this._index = parseInt(query) - this._startIndex;
        }
        this._index %= (this._numOfChildren / itemsPerPage);
        if (this._index < 0) {
            this._index += (this._numOfChildren / itemsPerPage);
        }
        const percent = this._index * -100;
        this._container.style.transform = `translateX(${percent}%)`;
        this.$onChange();

        var event = new CustomEvent('move', {
            detail: {
                index: this._index + this._startIndex
            }
        });

        this.dispatchEvent(event);
        return this._index;
    }

    $onChange() {
        /**
         * Extendable function
         */
    }
};

u.Carousel.register('u-carousel');

u.CarouselNav = class extends u.ForElement {
    /**
     *
     */
    createdCallback() {
        /**
         *
         */
        super.createdCallback();
        this.isHighlightActive = this.getAttribute('highlight') === 'true';

    }

    attachedCallback() {
        /**
         *
         */
        super.attachedCallback();

        if (this.isHighlightActive) {
            this.$forElement.addEventListener('move', (evt) => {
                if (parseInt(this.toIndex) === evt.detail.index) {
                    this.classList.add('active');
                } else {
                    this.classList.remove('active');
                }
            });
        }
    }
};

u.CarouselNav.register('u-carousel-nav');
u.CarouselMove = class extends u.CarouselNav {
    /**
     *
     */
    createdCallback() {
        /**
         *
         */
        super.createdCallback();
        this.toIndex = this.getAttribute('u-to');

        this._click = () => {
            this.$forElement.$moveTo(this.toIndex);
        };

    }

    attachedCallback() {
        /**
         *
         */
        super.attachedCallback();
        this.addEventListener('click', this._click);

    }
    
    detachedCallback() {
        /**
         *
         */
        this.removeEventListener('click', this._click);        
    }    
};

u.CarouselMove.register('u-carousel-move');
u.CarouselSwipe = class extends u.CarouselNav {
    /**
     *
     */
    createdCallback() {
        /**
         *
         */
        super.createdCallback();

        // credit to http://stackoverflow.com/questions/2264072/detect-a-finger-swipe-through-javascript-on-the-iphone-and-android
        this._handleTouchStart = (evt) => {
            u.CarouselSwipe.xDown = evt.touches[0].clientX;
            u.CarouselSwipe.yDown = evt.touches[0].clientY;
        }

        this._handleTouchMove = (evt) => {
            if ( ! u.CarouselSwipe.xDown || ! u.CarouselSwipe.yDown ) {
                return;
            }

            var xUp = evt.touches[0].clientX;
            var yUp = evt.touches[0].clientY;

            var xDiff = u.CarouselSwipe.xDown - xUp;
            var yDiff = u.CarouselSwipe.yDown - yUp;

            if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) { // most significant
                if ( xDiff > 0 ) {
                    // right swipe
                    this.$forElement.$moveTo('+1');
                } else {
                    // left swipe
                    this.$forElement.$moveTo('-1');
                }
            }
            u.CarouselSwipe.xDown = null;
            u.CarouselSwipe.yDown = null;
        }
    }

    attachedCallback() {
        /**
         *
         */
        super.attachedCallback();
        this.addEventListener('touchstart', this._handleTouchStart, false);
        this.addEventListener('touchmove', this._handleTouchMove, false);

    }

    detachedCallback() {
        /**
         *
         */
        this.removeEventListener('touchstart', this._handleTouchStart);
        this.removeEventListener('touchmove', this._handleTouchMove);
    
    }
};

u.CarouselSwipe.xDown = null;
u.CarouselSwipe.yDown = null;
u.CarouselSwipe.register('u-carousel-swipe');
u.Openable = class extends u.BaseElement {
    /**
     *
     */
    createdCallback() {
        /**
         *
         */        
        super.createdCallback();

        this._click = (evt) => {
            let parent = evt.target;
            while (parent) {
                if (parent === this) {
                    return;
                }
                parent = parent.parentElement;
            }
            evt.preventDefault();
            this.$close();
        };
        
        this._keyup = (evt) => {
            if (evt.keyCode === 27) {
                this.$close();
            }
        };
    }

    detachedCallback() {
        /**
         * Cleanup element on detachment
         */
        this.$close();
    }
    
    $toggle() {
        /**
         * Toggle the element open and close
         */
        if (this.classList.contains('open')) {
            this.$close();
        } else {
            this.$open();
        }
    }    

    $open() {
        /**
         * Open the element
         */

        document.addEventListener('click', this._click);
        document.addEventListener('keyup', this._keyup);
        document.body.style.overflowY = 'hidden';
        this.classList.add('open');
        this.dispatchEvent(new Event('u-modal-open'));
    }

    $close() {
        /**
         * Close the element
         */

        document.removeEventListener('click', this._click);
        document.removeEventListener('keyup', this._keyup);
        document.body.style.overflowY = 'inherit';
        this.classList.remove('open');
        this.dispatchEvent(new Event('u-modal-close'));
    }
};

u.Modal = class extends u.Openable {
    createdCallback() {
        /**
         * example:
         *
         * <u-modal id="modal-dev-license" class="sb.modal" u-backdrop="static" u-show="true">
         *
         * options:
         *
         *
         * u-backdrop
         *
         * static: disable the background. the user can close the modal only when it is explicitly requested
         *
         * u-show
         *
         * true: the modal is visible by default
         *
         *
         * closetext:
         *
         * You may add a class="sb.modal.closetext" to a tag in order to make the element a close tag
         *
         */
        super.createdCallback();


        const backdropType = this.getAttribute('u-backdrop');
        const staticBackdrop = (backdropType !== null && backdropType.toLowerCase() === 'static');

        this.backdrop = this.firstElementChild; // backdrop has to be the immediate child of u-modal

        // If we don't have a 'static' backdrop and we have a proper modal backdrop element, close when it's clicked
        if (!staticBackdrop && this.backdrop.className.indexOf('sb.modal.backdrop') >= 0) {
            this.backdrop.addEventListener('click', (evt) => {
                if (evt.target !== this.backdrop) { // but don't close if the modal window itself is clicked!
                    return;
                }
                this.$close();
            });
        }

        // if static, don't close the modal when the esc key is hit. overwrite inherited u.Openable functionality.
        if (staticBackdrop) {
            this._keyup = (evt) => {
                if (evt.keyCode === 27) {
                    // do nothing
                }
            };
        }

        const show = this.getAttribute('u-show');
        if (show !== null && (show.toLowerCase() === 'true' || show === '1')) {
            this.$open();
        }

        const closeText = this.querySelectorAll('.sb\\.modal\\.closetext');
        if(closeText.length > 0) {
            closeText[0].addEventListener('click', (evt) => {
                this.$close();
            });
        }
    }
};

u.Modal.register('u-modal');

u.ModalCookie = class extends u.Modal {

    createdCallback() {
        super.createdCallback();

        // look at cookie to see if cookie policy was already accepted. if not, display cookie policy modal.
        var cooky = readCookie('splunkbase_cookie_policy_accepted');
        if (!cooky) {
            this.$open();
        }
    }

    attachedCallback() {
        super.attachedCallback();

        // cookie policy modal accept button
        const acceptText = this.querySelectorAll('.sb\\.modal\\.accepttext');
        if(acceptText.length > 0) {
            acceptText[0].addEventListener('click', (evt) => {
                this.$close();

                // set cookie to expire one year from now
                const oneYear = new Date(new Date().setFullYear(new Date().getFullYear() + 1))
                document.cookie = "splunkbase_cookie_policy_accepted=true; expires=" + oneYear.toUTCString() + "; path=/"

                document.dispatchEvent(new Event('u-modal-cookie-close'));

                // log cookie acceptance
                const xhr = new XMLHttpRequest();
                xhr.open('GET', `/api/v0/log/cookie_accept`);
                xhr.setRequestHeader('X-CSRFToken', getCsrfToken());
                xhr.send();
            });
        }
    }
}
u.ModalCookie.register('u-modal-cookie');

u.ModalDDL = class extends u.Modal {
    createdCallback() {
        super.createdCallback();

        // override the click event in u.Openable
        this._click = (evt) => {
            // do nothing
        };
        
        // look at cookie to see if cookie policy was already accepted. if it was, open. if it wasn't, listen for u-modal-cookie-close
        var cooky = readCookie('splunkbase_cookie_policy_accepted');
        if (cooky) {
            this.$open();
        } else {
            // open the ddl modal when cookie modal is closed
            document.addEventListener('u-modal-cookie-close', (evt) => {
                this.$open();
            });
        }
    }

    attachedCallback() {
        super.attachedCallback();
        // DDL modal accept button
        const acceptText = this.querySelectorAll('.sb\\.modal\\.accepttext');
        if(acceptText.length > 0) {
            acceptText[0].addEventListener('click', (evt) => {
                this.$close();
            });
        }
    }
}
u.ModalDDL.register('u-modal-ddl');

u.Drawer = class extends u.Openable {};
u.Drawer.register('u-drawer');

u.MobileSearch = class extends u.Openable {
    $open() {
        super.$open();
        document.body.style.overflowY = 'inherit';
    }
};
u.MobileSearch.register('u-mobile-search');

// js tool for reading cookie. hat tip: https://www.quirksmode.org/js/cookies.html
function readCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}
u.AutoComplete = class extends u.ForElement {
    /**
     *
     */
    createdCallback() {
        /**
         *
         */
        super.createdCallback();

        this.style.position = 'absolute';
        this.style.cursor = 'pointer';
        this.style.zIndex = 1;

        this.$highlightClass = 'highlight';
        this.$hideTimeout = 500;
        this.$minLength = 1;

        this._latestValue = '';
        this._hideTimeout = 0;

        this._mouseDown = (evt) => {
            /**
             * When mouse down is fired, make sure it was the primary mouse button.
             */
            if (evt.button === 0) {
                let elem = evt.target;
                while (elem) {
                    if (elem instanceof u.AutoCompleteOption) {
                        this.$select(elem.$value);
                        return;
                    }
                    elem = elem.parentElement;
                }
            } else {
                evt.preventDefault();
            }
        }

        this._input = () => {
            /**
             * Handle input value change, give the update() time to respond before hiding the dropdown
             */
            const value = this.$forElement.value.trim();
            if (value !== this._latestValue) {
                this._latestValue = value;
                if (this._latestValue.length <= this.$minLength) {
                    this.$hide();
                } else {
                    clearTimeout(this._hideTimeout);
                    this._hideTimeout = setTimeout(() => this.$hide(), this.$hideTimeout);
                    this.$input(this._latestValue);
                }
            }
        };

        this._keyDown = (evt) => {
            /**
             *
             */
            switch (evt.keyCode) {
                // down
                case 40:
                    /**
                     * Highlight a option downward and prevent courser from moving to the end
                     */
                    evt.preventDefault();
                    if (this.children.length) {
                        const highlighted = this.$highlighted();
                        if (highlighted) {
                            highlighted.classList.remove(this.$highlightClass);
                            const next = highlighted.nextElementSibling;
                            if (next) {
                                next.classList.add(this.$highlightClass);
                            }
                        } else {
                            const first = this.firstElementChild;
                            first.classList.add(this.$highlightClass);
                        }
                    }
                    break;

                // up
                case 38:
                    /**
                     * Highlight a option upward and prevent courser from moving to the beginning
                     */
                    evt.preventDefault();
                    if (this.children.length) {
                        const highlighted = this.$highlighted();
                        if (highlighted) {
                            highlighted.classList.remove(this.$highlightClass);
                            const prev = highlighted.previousElementSibling;
                            if (prev) {
                                prev.classList.add(this.$highlightClass);
                            }
                        } else {
                            const last = this.lastElementChild;
                            last.classList.add(this.$highlightClass);
                        }
                    }
                    break;

                // enter
                case 13:
                    /**
                     * Prevent enter from triggering form submission when option is selected
                     */
                    const highlighted = this.$highlighted();
                    if (highlighted) {
                        evt.preventDefault();
                        this.$select(highlighted.$value);
                    } else {
                        this.$hide();
                        evt.preventDefault();
                        const value = this.$forElement.value.trim();
                        this.$search(value);
                        this.$forElement.value = '';
                    }
                    break;

                // esc
                case 27:
                    /**
                     * Just hide on ESC key
                     */
                    this.$hide();
                    break;
            }
        };

        this._blur = () => {
            /**
             * Hide on blur
             */
            this.$hide();
        }

        this._focus = () => {
            /**
             * Show on focus if options are available
             */
            if (this.children.length) {
                this.$show();
            }
        };

        this._resize = () => {
            /**
             *
             */
            this.$position();
        };
    }

    attachedCallback() {
        /**
         *
         */
        super.attachedCallback();
        this.$forElement.autocomplete = 'off';
        this.$position();

        // event listeners
        window.addEventListener('resize', this._resize);
        this.addEventListener('mousedown', this._mouseDown);
        this.$forElement.addEventListener('blur', this._blur);
        this.$forElement.addEventListener('focus', this._focus);
        this.$forElement.addEventListener('input', this._input);
        this.$forElement.addEventListener('keydown', this._keyDown);
    }

    detachedCallback() {
        /**
         *
         */
        super.detachedCallback();
        window.removeEventListener('resize', this._resize);
        this.removeEventListener('mousedown', this._mouseDown);
        this.$forElement.removeEventListener('blur', this._blur);
        this.$forElement.removeEventListener('focus', this._focus);
        this.$forElement.removeEventListener('input', this._input);
        this.$forElement.removeEventListener('keydown', this._keyDown);
    }

    $input(value) {
        /**
         * Default callback for when the input has changed
         */
    }

    $select(value) {
        /**
         * Default callback for when a option is selected
         */
        this.$hide();
        this.$forElement.value = value;
    }

    $search(value) {

    }

    $update(value, options) {
        /**
         * Callback for when options are ready to be updated
         */
        if (this._latestValue === value) {

            // remove old nodes
            let child;
            while (child = this.firstChild) {
                this.removeChild(child);
            }

            if (options.length) {
                options.forEach((value) => {
                    const elem = document.createElement('u-autocomplete-option');
                    elem.$value = value;
                    elem.$parent = this;                    
                    this.$add(elem, value);
                    this.appendChild(elem);
                });
                this.$show();
            }
        }
    }

    $add(elem, value) {
        /**
         * Default callback for when a new option is added
         */
        elem.textContent = value;
    }

    $show() {
        /**
         * Reveals the AutoComplete element
         */
        clearTimeout(this._hideTimeout);
        this.style.display = 'block';
    }

    $hide() {
        /**
         * Hide the AutoComplete element
        */
        clearTimeout(this._hideTimeout);
        this.style.display = 'none';
        const highlighted = this.$highlighted();
        if (highlighted) {
            highlighted.classList.remove(this.$highlightClass);
        }
    }

    $highlighted() {
        /**
         * Get the current highlighted option element
         */
        const children = this.children;
        for (let i = 0, child; child = children[i]; i++) {
            if (child.classList.contains(this.$highlightClass)) {
                return child;
            }
        }
        return null;
    }

    $position() {
        /**
         * Set the positioning of the autocomplete container
         */
        var rect = this.$forElement.getBoundingClientRect();
        if (rect.width > 0) {
            this.style.width = rect.width + 'px';
        }
    }
};

u.AutoComplete.register('u-autocomplete');

u.AutoCompleteOption = class extends u.BaseElement {
    /**
     * 
     */
    createdCallback() {
        /**
         * 
         */
        super.createdCallback();

        this.style.display = 'block';
        this.style.overflowX =  'hidden';
        this.style.textOverflow = 'ellipsis';
        this.style.whiteSpace = 'nowrap';

        this.$parent = null;
        this.$value = null;
        
        this._mouseEnter = (evt) => {
            /**
             * When mouse event is fired, make sure it was the primary mouse button
             */
            if (evt.button === 0) {
                const highlighted = this.$parent.$highlighted();
                if (highlighted) {
                    highlighted.classList.remove(this.$parent.$highlightClass);
                }
                this.classList.add(this.$parent.$highlightClass);
            } else {
                evt.preventDefault();
            }
        };
    }
    
    attachedCallback() {
        /**
         *
         */
        super.attachedCallback();
        this.addEventListener('mouseenter', this._mouseEnter);         
    }

    detachedCallback() {
        /**
         *
         */
        super.detachedCallback();        
        this.removeEventListener('mouseenter', this._mouseEnter);        
    }
};

u.AutoCompleteOption.register('u-autocomplete-option');

u.Tabs = class extends u.BaseElement {
    /**
     *
     */
    createdCallback() {
        /**
         *
         */
        super.createdCallback();
        this._active = this.firstElementChild; // the default active tab is the first one
        this._tabs = this.children;
        this.$changeActive();
    }

    $moveTo(query) {
        /**
         *
         */

        this._active = this.querySelector('#' + query);
        this.$changeActive();
        this.$onChange();
    }

    $changeActive() {
        // hide everything
        for (var i = 0; i< this._tabs.length; i++) {
            this._tabs[i].classList.add('u.hide@*');
        }
        // make active tab visible
        this._active.classList.remove('u.hide@*');
    }

    $onChange() {
        /**
         * Extendable function
         */
    }
};

u.Tabs.register('u-tab');
u.TabSelect = class extends u.ForElement {
    /**
     *
     */
    createdCallback() {
        /**
         *
         */
        super.createdCallback();

        this._click = () => {
            this.selectTab();

            window.location.hash = this.getAttribute('data-hash');
        };
    }

    attachedCallback() {
        /**
         *
         */
        super.attachedCallback();
        this.addEventListener('click', this._click);
        u.TabSelect.items.push(this); // add each tab to the set of tab-select elements
    }

    detachedCallback() {
        /**
         *
         */
        this.removeEventListener('click', this._click);        
    }

    selectTab() {
        // style all tabs as inactive
        const tabSet = this.getAttribute('u-for');
        const numTabs = this.firstElementChild.parentNode.parentNode.children.length; 
        for (var i = 0; i< u.TabSelect.items.length; i++) {
            if (u.TabSelect.items[i].getAttribute('u-for') === tabSet) {
                u.TabSelect.items[i].firstElementChild.classList.remove(u.TabSelect.activeStyle);
            }
        }

        // style active tab
        // BASE-3829 - remove details tab when no content
        if(numTabs>1){
            this.firstElementChild.classList.add(u.TabSelect.activeStyle);
            const val = this.getAttribute('u-to');
            this.$forElement.$moveTo(val);
        }
    }
};

u.TabSelect.items = [];
u.TabSelect.activeStyle = 'c-details-body__tab--active';  // TODO this should be more dynamic
u.TabSelect.register('u-tab-select');

$(document).ready(function() {
    // we want to support permalink for the details page. Depends on the hash,
    // we highlight the right one but this must be done on Dom Ready
    const hash = window.location.hash;
    for(let item of u.TabSelect.items) {
        if (item.getAttribute('data-hash') === hash) {
            item.selectTab();
        }
    }
});


u.Menu = class extends u.BaseElement {
    /**
     *
     */
    createdCallback() {
        /**
         *
         */
        super.createdCallback();
    }

    detachedCallback() {
        /**
         * Cleanup element on detachment
         */
        this.$close();
    }

    $open() {
        /**
         * Open the element
         */

        this.classList.add('open');
    }

    $close() {
        /**
         * Close the element
         */

        this.classList.remove('open');
    }

    $toggle() {
        /**
         * Toggle the element open and close
         */
        if (this.classList.contains('open')) {
            this.$close();
        } else {
            this.$open();
        }
    }
};

u.Menu.register('u-menu');
u.ToggleHover = class extends u.ForElement {
    /**
     *
     */
    attachedCallback() {
        /**
         *
         */
        super.attachedCallback();
        this.addEventListener('mouseover', (evt) => {
            evt.preventDefault();
            this.$forElement.$open();
        });
        this.addEventListener('mouseout', (evt) => {
            evt.preventDefault();
            this.$forElement.$close();
        });
    }

};
u.ToggleHover.register('u-toggle-hover');

/* To make this work, you have to extend this class to
   1) define a listener that processes your specific form in attachedCallback()
   2) define a $closeModal function with your form's modal id
   There is probably a better way to do this...
 */


u.ModalForm = class extends u.BaseForm {

    attachedCallback(){
        super.attachedCallback();
        document.addEventListener('sb-captcha-success', function (event) {
            this.elements.submitbtn.classList.remove('u.btn:blue');
            this.elements.submitbtn.classList.add('u.btn:green');
            this.recaptchaResponse = event.detail.response;
        }.bind(this));

        this.message = this.querySelector('.error');
        this.close = false;
        this.$clearMsg();

        this.addEventListener('submit', (event) => {
            event.preventDefault();

            if (!this.checkValidity()) {
                return;
            }
            
            // if the form was already submitted then handle close
            if (this.close) {
                this.$closeModal();
                return;
            }

            // if recaptcha is not done, abort
            if (this.elements['g-recaptcha-response'].value!==this.recaptchaResponse) {
                window.grecaptcha.reset();
                this.$error('Please prove that you are not a robot.');
                return;
            }

            this.$clearMsg();
            this.$submit(event);
        });

        this.addEventListener('click', this._click);
    }

    $submit(event) {
        // extend me
    }

    $onSuccess() {
        this.$success("Thank you for your feedback.");
        this.elements.submitbtn.value = "Close";
        this.close = true;

        for(let element of this.elements) {
            if(element !== this.elements.submitbtn) {
                element.disabled = true;
            }
        }
    }

    $closeModal() {
        window.location.reload(false);
    }

    $error(message) {
        this.$clearMsg();
        this.message.classList.add('sb.color:red');
        this.message.textContent = message;
    }

    $clearMsg() {
        this.message.classList.remove('sb.color:red');
        this.message.textContent = '';
    }

    $success(message) {
        this.$clearMsg();
        this.message.textContent = message;
    }
}

u.ModalForm.register('u-modal-form');
var _gaq = _gaq || [];
_gaq.push(['_setAccount', 'UA-399680-1']);
_gaq.push(['_setDomainName', 'splunk.com']);
_gaq.push(['_trackPageview']);
(function() {
    var ga = document.createElement('script');
    ga.type = 'text/javascript';
    ga.async = true;
    ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(ga, s);
})();

const sb = {};
function getCsrfToken() {
    var name = 'csrf_splunkbase_token';
    if (document.cookie) {
        var cookies = document.cookie.split(';');
        var i;
        for (i = 0; i < cookies.length; i += 1) {
            var cookie = cookies[i].trim();
            if (cookie.substring(0, name.length) === name) {
                var csrf = cookie.substring(name.length + 1);
                return csrf;
            }
        }
    }
    return '';
}

(class extends u.BaseElement {
    createdCallback() {
        let strDate = this.getAttribute('sb-date');
        let localDate = new Date(Date.parse(strDate));
        const span = document.createElement('span');
        let convertedDate = localDate.toDateString() + ' ' +
                         localDate.toLocaleTimeString() + ' ' +
                         localDate.toString().match(/\(([A-Za-z\s].*)\)/)[1];
        span.innerHTML = convertedDate;
        this.appendChild(span);
    }
}).register('sb-local-date');

sb.reCaptcha = class extends u.BaseElement {
    attachedCallback() {
        super.attachedCallback();
        this.siteKey = this.getAttribute('sitekey');
        this.$init();
    }

    $init() {
        sb.reCaptcha.widgets.push(this);

        if(window.reCaptchaOnload === undefined) {
            window.reCaptchaOnload = function () {
                let recaptcha = window.grecaptcha;
                for(let widget of sb.reCaptcha.widgets) {
                    recaptcha.render(
                        widget.id, {
                            sitekey: widget.siteKey,
                            callback: widget.$responseCallback.bind(widget)
                        });
                }
            };
        }
    }

    $responseCallback(response) {
        var event = new CustomEvent('sb-captcha-success', {
            detail: {
                id: this.id,
                response: response
            }
        });
        document.dispatchEvent(event);
    }
};
sb.reCaptcha.widgets = [];
sb.reCaptcha.register('sb-captcha');

(class extends u.AnchorElement {
    createdCallback () {
        // if user is anonymous
        if (context.username === null) {
            var loginUrl = context.login_sso;
            // var loginUrl = 'https://' + context.login_sdc + '/index.php?module=roles&func=showloginform&redirecturl=';
            this.setAttribute('href', loginUrl + encodeURIComponent(window.location))
        }
    }
}).register('sb-auth-required');

(class extends u.BaseElement {
    createdCallback() {
        if (!context.is_directory_listing) {
            this.innerHTML = '"' + context.app_name + '" is not a directory listing. No action taken.';
        }
        else {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', `/api/v0/app/${context.appid}/validate_url/`);
            xhr.onload = () => {
                if (xhr.readyState === 4) {
                    this.innerHTML = xhr.responseText;
                }
            }
            xhr.send();
        }
    }
}).register('sb-validate-url');

sb.AutoCompleteArchiveOption = class extends u.AutoCompleteOption {
    /**
     *
     */
    createdCallback() {
        /**
         *
         */
        super.createdCallback();

        this.style.display = 'block';
        this.style.overflowX =  'hidden';
        this.style.textOverflow = 'ellipsis';
        this.style.whiteSpace = 'nowrap';

        this.style.cursor = 'default';
        this.style.wordWrap = 'break-word';
        this.style.textAlign = 'center';
        this.style.whiteSpace = 'normal';
        this.appendChild(document.createTextNode("Not seeing what you're looking for? Check the "));

        let a = document.createElement('a');
        a.style.cursor = 'pointer';
        a.style.color = '#05A2D6';
        a.innerText = 'Archived Apps';
        a.href = '/archive/apps/#/order/popular';
        this.appendChild(a);
        this.appendChild(document.createTextNode(' page.'));

        this.$parent = null;

        this._mouseEnter = (evt) => {
            if (evt.button === 0) {
                const highlighted = this.$parent.$highlighted();
                if (highlighted) {
                    highlighted.classList.remove(this.$parent.$highlightClass);
                }
            }
        };
    }

    attachedCallback() {
        super.attachedCallback();
        this.addEventListener('mouseenter', this._mouseEnter);
    }

    detachedCallback() {
        super.detachedCallback();
        this.removeEventListener('mouseenter', this._mouseEnter);
    }
};

sb.AutoCompleteArchiveOption.register('sb-autocomplete-archive-option');

sb.AutoComplete = class extends u.AutoComplete {
    /**
     *
     */
    createdCallback() {
        super.createdCallback();
        this._mouseDown = (evt) => {
            if (evt.button === 0) {
                let elem = evt.target;
                while (elem) {
                    if (elem instanceof u.AutoCompleteOption) {
                        this.$select(elem.$value);
                        return;
                    }
                    if (elem.href) {
                        window.location = elem.href;
                        return;
                    }
                    elem = elem.parentElement;
                }
            } else {
                evt.preventDefault();
            }
        };
    };

    $input(value) {
        /**
         * 
         */
        const xhr = new XMLHttpRequest();
        xhr.onload = () => {
            this.$update(value, JSON.parse(xhr.responseText).results);
        };
        xhr.open('GET', '/api/v1/search/autocomplete/?q=' + value + '&archiving=false', true);
        xhr.send();
    };

    $update(value, options) {
        if (this._latestValue === value) {

            // remove old nodes
            let child;
            while (child = this.firstChild) {
                this.removeChild(child);
            }

            if (options.length) {
                options.forEach((value) => {
                    const elem = document.createElement('u-autocomplete-option');
                    elem.$value = value;
                    elem.$parent = this;
                    this.$add(elem, value);
                    this.appendChild(elem);
                });

                const archive_elem = document.createElement('sb-autocomplete-archive-option');
                archive_elem.$parent = this;
                this.appendChild(archive_elem);
                this.$show();
            }
        }
    };

    $add(elem, value) {
        /**
         *
         */
        const img = document.createElement('img');
        const span = document.createElement('span');
        img.src = value.icon_url;
        span.textContent = value.name;
        elem.appendChild(img);
        elem.appendChild(span);
    };

    $select(value) {
        if (value) {
            window.location = '/app/' + value.pk + '/';
        }
    };

    $search(value) {
        value = encodeURI(value);
        window.location = '/apps/#/search/' + value + '/';
    };

    // _boldSpan(title) {
    //     /**
    //      * TODO: New designs don't have this, but I'm keeping for now because you never know.
    //      */
    //     const span = document.createElement('span');
    //     const re = new RegExp(this.input.value.split(' ').filter(function (val) {
    //         return !!val;
    //     }).join('|'), 'ig');
    //
    //     const highlight = [];
    //
    //     let counter = 0;
    //     let match;
    //     let content;
    //     let node;
    //
    //     while ((match = re.exec(title)) !== null) {
    //         highlight.push({start: match.index, length: match[0].length});
    //     }
    //
    //     for (let i = 0; i < highlight.length; i++) {
    //         let start = highlight[i].start;
    //         let length = highlight[i].length;
    //
    //         content = title.slice(counter, start);
    //         node = document.createTextNode(content);
    //         span.appendChild(node);
    //
    //         content = title.substr(start, length);
    //         node = document.createElement('strong');
    //         node.textContent = content;
    //         span.appendChild(node);
    //
    //         counter = start + length;
    //     }
    //
    //     content = title.substr(counter, title.length - counter);
    //     node = document.createTextNode(content);
    //     span.appendChild(node);
    //
    //     return span;
    // }
};

sb.AutoComplete.register('sb-autocomplete');

// sb-search-storage
sb.SearchStorage = class extends u.Storage {
    createdCallback() {
        this.isArchive = this.getAttribute('archive') === 'true';
    }

    attachedCallback() {
        super.attachedCallback();

        this._lastQuery = '';
        this.isRefreshDisabled = false;
        this.offset = 0;

        this.$set('results', []);
        this.$set('viewType', 'simple');

        this.$listen('filters', this.$changeFilter.bind(this));
        this.$listen('search', this.$changeFilter.bind(this));
        this.$listen('order', this.$changeFilter.bind(this));

        window.addEventListener('hashchange', this.$parseURL.bind(this));
        sb.SearchStorage.instances.push(this);
    }

    $callApi() {
        if (!this.isRefreshDisabled) {
            const queries = this.$buildQuery();
            this._lastQuery = queries.queryString;
            const xhr = new XMLHttpRequest();
            xhr.open('GET', `/api/v0/apps/?${queries.queryString}`);
            xhr.onload = () => {
                if (xhr.readyState === 4 && queries.queryString === this._lastQuery) {
                    const result = JSON.parse(xhr.responseText);
                    this.$set('results', result);
                    this.$sendGoogleAnalytics(queries.loggedQueries, this.offset, result.total);
                    this.offset = result.last;
                }
            };
            xhr.send();
        }
    }

    $changeFilter() {
        if (!this.isRefreshDisabled) {
            this.offset = 0;
            this.$callApi();
            this.$buildUrl();
        }
    }

    $loadMore() {
        this.$callApi();
    }

    $disableRefresh() {
        this.isRefreshDisabled = true;
    }

    $enableRefresh() {
        this.isRefreshDisabled = false;
    }

    $sendGoogleAnalytics(queries, offset, total) {
        // Only send under certain circumstances...
        // offset === 0: this is the first search - not subsequent searches due to pagination
        // "search" in queries: user searched for a string. Don't send if they just used filters with no search string
        if (offset === 0 && "search" in queries) {
            // sort queries by key ("search", "products", etc) so it's organized properly in google analytics
            let sorted = [];
            for (let key in queries) {
                sorted[sorted.length] = key;
            }
            sorted.sort();

            // put the sorted queries into a human readable string
            let searchParams = [];
            for (let key in sorted) {
                searchParams.push(sorted[key] + '=' + queries[sorted[key]]);
            }
            const joined_params = searchParams.join(', ');
            _gaq.push(['_trackEvent', 'Search', 'apps', joined_params, total]);
        }
    }

    $parseURL() {
        /**
         * when a page is first loaded or the url changes, we must parse the URL to pre-fill the filters
         * based on the fragment
         *
         * TODO(bchoi): change the frag to browser history in the future
         */

        // this.$set() fires callapi. We want to fire callApi when we are all done loading the filters based on
        // the url fragments
        this.$disableRefresh();

        this.$clearFilters();

        const hashes = window.location.hash.split('/');
        for (let i = 1; i < hashes.length; i += 2) {
            let filterType = hashes[i],
                value = decodeURIComponent(hashes[i + 1]);
            // Escape value to prevent XSS
            value = value.replace(/&/g, '').replace(/</g, '').replace(/>/g, '').replace(/"/g, '').replace(/'/g, '').replace(/\//g, '');
            if (filterType && value) {
                if (filterType in this.$get('filters')) {
                    let values = value.split(',');
                    for (let value of values) {
                        this.$set('filters|' + filterType + '|' + value, true);
                    }
                } else {
                    this.$set(filterType, value, true);
                }
            }
        }
        this.$enableRefresh();
        this.offset = 0;
        this.$callApi();
    }

    $buildQuery() {
        let queries = [];
        let loggedQueries = {}; // for google analytics

        const search = this.$get('search');
        let order = this.$get('order');
        let options = {};

        options.relevance = document.getElementById('sortrelevance'); 
        options.latest = document.getElementById('sortlatest');
        options.popular = document.getElementById('sortpopular');

        queries.push(`offset=${this.offset}`);

        options.relevance.removeAttribute('selected');
        options.latest.removeAttribute('selected');
        options.popular.removeAttribute('selected');

        // if keyword search is in place, we need to take care of some logistics
        if (search) {
            // If there's a search, enable/show the relevance sort option
            options.relevance.disabled = false;
            options.relevance.classList.remove("u.hide@*");

            queries.push(`search=${search}`);
            loggedQueries['search'] = search.toLowerCase();

            // if no order is selected, go with relevance order by default
            if (!order) {
                queries.push('order=relevance');
                options.relevance.selected = true;
            } else {
                queries.push(`order=${order}`);
                options[order].selected = true;
            }
        } else {

            // If there's no search, disable/hide the relevance sort option
            // this won't hide it in all browsers, hence disabling too
            options.relevance.classList.add("u.hide@*"); 
            options.relevance.disabled = true;

            // if no order is selected, go with newest order by default
            if (!order) {
                queries.push('order=latest');
                options.latest.selected = true;
            } else {
                queries.push(`order=${order}`);
                options[order].selected = true;
            }
            if (this.isArchive) {
                options.latest.selected = false;
                options.popular.selected = true;
                queries.push('order=popular');
            }
        }

        if (this.isArchive) {
            queries.push('archive=true');
        }else{
            queries.push('archive=false');
        }

        const obj = this.$get('filters');
        for (let filter of Object.keys(obj)) {
            let filters = [];
            for (let item of Object.keys(obj[filter])) {
                if (obj[filter][item] === true) {
                    filters.push(item);
                }
            }
            if (filters.length > 0) {
                queries.push(`${filter}=${filters.join(',')}`)
                loggedQueries[filter] = filters.join(',');
            }
        }

        return {queryString:queries.join('&'), loggedQueries:loggedQueries};
    }

    $buildUrl() {
        let params = [];

        const order = this.$get('order');
        if(order) {
            params.push(`order/${order}`);
        }

        const search = this.$get('search');
        if (search) {
            // URL encode the search keywords
            const uriSearch = encodeURI(search);
            // put the search keywords into the URL
            params.push(`search/${uriSearch}`);
        }

        const obj = this.$get('filters');
        for (let filter of Object.keys(obj)) {
            let filters = [];
            for (let item of Object.keys(obj[filter])) {
                if (obj[filter][item] === true) {
                    filters.push(item);
                }
            }
            if (filters.length > 0) {
                params.push(`${filter}/${filters.join(',')}`)
            }
        }
        history.pushState(null, null, '#/' + params.join('/'));
    }
    
    $clearFilters() {
        this.$set('filters', {});
        this.$set('filters|product', {});
        this.$set('filters|category', {});
        this.$set('filters|technology', {});
        this.$set('filters|type', {});
        this.$set('filters|app_content', {});
        this.$set('filters|version', {});
        this.$set('filters|cim', {});
        this.$set('filters|status', {});
        this.$set('filters|author', {});
        this.$set('filters|archive', {});
        this.$set('filters|validation', {});
        this.$set('order', '');
        this.$set('search', '');
        this.$set('offset', 0);
    }
}

sb.SearchStorage.instances = [];
sb.SearchStorage.register('sb-search-storage');

// sb-search-toggle
u.SearchToggle = class extends u.BaseElement {
    attachedCallback() {
        const group = this.getAttribute('group');
        if (!u.SearchToggle.groups.hasOwnProperty(group)) {
            u.SearchToggle.groups[group] = [];
        }

        u.SearchToggle.groups[group].push(this);

        super.attachedCallback();
        this.addEventListener('click', () => {
            this.classList.toggle('open');
            for (let toggle of u.SearchToggle.groups[group]) {
                if (toggle !== this) {
                    toggle.classList.remove('open');
                }
            }
        });
    }
};
u.SearchToggle.groups = {};
u.SearchToggle.register('sb-search-toggle');


// sb-filter-count
(class extends u.Bind {
    $onChange(value) {
        
        let count = 0;
        for (let key of Object.keys(value)) {
            if (value[key]) {
                count++;
            }
        }

        if (count) {
            this.textContent = count;
            this.classList.add('show');
        } else {
            this.classList.remove('show');
        }
    }
}).register('sb-filter-count');

// sb-search-checkbox
(class extends u.ConsumerInput {
    attachedCallback() {
        super.attachedCallback();
        this.searchfield = this.getAttribute('searchfield');
        if (this.searchfield !== null) {
            this.searchfield = this.getAttribute('searchfield');
            this.parentPath = `filters|${this.searchfield}`;
        } else {
            this.parentPath = `filters|${this.name}`;
        }
        this.path = `${this.parentPath}|${this.value}`;

        this.$storage.$listen(this.parentPath, this.$onClear.bind(this));
        this.$storage.$listen(this.path, this.$onChange.bind(this));

        this.addEventListener('change', () => {
            this.$storage.$set(this.path, this.checked ? true : false);
        });
    }

    $onChange(value) {
        this.checked = value;
    }

    // when filters are being cleared, we need to make sure all of checkboxes get cleared too.
    $onClear(value) {
        if (Object.keys(value).length === 0) {
            this.checked = false;
        }
    }
}).register('sb-search-checkbox');

// sb-bind
u.SbBind = class extends u.Bind {
    attachedCallback() {
        super.attachedCallback();
        this.$key = this.getAttribute('bind-key');
    }
    $onChange(value) {
        super.$onChange(value[this.$key]);
    }
};
u.SbBind.register('sb-bind');


// sb-results
(class extends u.Bind {
    attachedCallback() {
        super.attachedCallback();
        this.$key = this.getAttribute('bind-key');
    }
    $onChange(value) {
        // message for no results returned
        const no_results = document.querySelector('p[is=sb-no-results]');
        // hide sort select if no results returned
        const sort_select = document.querySelector('select[is=order-select]');

        if (value[this.$key] > 0) {
            no_results.classList.add('u.hide@*');
            sort_select.classList.remove('u.hide@*');
            this.classList.remove('u.hide@*');
        } else {
            no_results.classList.remove('u.hide@*');
            sort_select.classList.add('u.hide@*');
            this.classList.add('u.hide@*');
        }
    }
}).register('sb-results');


// sb-search
(class extends u.ConsumerInput {
    attachedCallback() {
        super.attachedCallback();
        this.addEventListener('change', ()=> {
            if (this.value) {
                this.$storage.$set('search', this.value);
            } else {
                this.$storage.$set('search', '');
            }
        });
    }
}).register('sb-search-input');

(class extends u.ConsumerInput {
    attachedCallback() {
        super.attachedCallback();
        this.addEventListener('change', ()=> {
            if (this.value) {
                this.$storage.$set('search', this.value);
            } else {
                this.$storage.$set('search', '');
            }
        });
    }
}).register('sb-archive-search-input');

// order-select
(class extends u.ConsumerSelect {
    attachedCallback() {
        super.attachedCallback();

        this.path = `${this.name}`;

        this.$storage.$listen(this.path, this.$onChange.bind(this));

        this.addEventListener('change', ()=> {
            this.$storage.$set('order', this.value);
        });
    }

    $onChange(value) {
        this.value = value;
    }
}).register('order-select');

// toggle for details vs. simple view
sb.SearchViewToggle = class extends u.Consumer {
    attachedCallback() {
        super.attachedCallback();

        this.viewType = this.getAttribute('type');
        sb.SearchViewToggle.items.push(this);

        this.addEventListener('click', ()=> {
            this.$storage.$set('viewType', this.viewType);

            // update button colors
            for (let i = 0; i < sb.SearchViewToggle.items.length; i++) {
                if (sb.SearchViewToggle.items[i].getAttribute('type') === this.viewType) {
                    sb.SearchViewToggle.items[i].firstElementChild.classList.add('active');
                } else {
                    sb.SearchViewToggle.items[i].firstElementChild.classList.remove('active');
                }
            }
        });
    }
};
sb.SearchViewToggle.items = [];
sb.SearchViewToggle.register('sb-view-toggle');

sb.AppCard = class extends u.Consumer {
    attachedCallback() {
        super.attachedCallback();
        this.type = this.getAttribute('type');
        this.$storage.$listen('viewType', this.$onChange.bind(this))

        // toggle based on the initial state when being added
        this.$onChange(this.$storage.$get('viewType'));
    }

    $onChange(value) {
        if(this.type === value) {
            this.classList.remove("u.hide@*");
        } else {
            this.classList.add("u.hide@*");
        }
    }
};
sb.AppCard.register('sb-app-card');
sb.AppCard.appCardsDetailed = [];
sb.AppCard.appCardsSimple = [];

// sb-search-pill
u.SbSearchPill = class extends u.Bind {
    attachedCallback() {
        super.attachedCallback();

        // canonical to display name map filled by sb-search-pill-map
        this.map = {};
        this.name = this.getAttribute('name');
    }

    $name(value) {
        // if the mapping exists, use it otherwise return the value as is
        if (value in this.map) {
            return this.map[value];
        }
        return value;
    }

    $onChange(value) {
        this.innerHTML = '';

        if (!value || value === undefined || value.length === 0) {
            return;
        }

        const self = this;
        const filters = [];

        if (typeof(value) === 'object') {
            for (let filter of Object.keys(value)) {
                if (value[filter]) {
                    filters.push({
                        name: this.$name(filter),
                        path: self.bindTo + "|" + filter
                    });
                }
            }
        } else {
            filters.push({
                name: this.$name(value),
                path: self.bindTo
            });
        }

        for (let filter of filters) {
            const button = document.createElement('button');
            button.className = "u.btn u.item c-search-pill";
            button.addEventListener('click', ()=> {
                self.$onRemove(filter.path);
            });

            const nameSpan = document.createElement('span');
            nameSpan.innerHTML = `${this.name}: `;

            // name:
            button.appendChild(nameSpan);

            const span = document.createElement('span');
            span.innerHTML = filter.name;

            const remove = document.createElement('span');
            remove.className = 'remove';
            remove.innerHTML = "<svg class='u.icon:tiny sb.color:gray-dark c-search-pill__close'><use xlink:href='#close-x'/></svg>";

            button.appendChild(span);
            button.appendChild(remove);
            this.appendChild(button);
        }
    }

    $onRemove(path) {
        this.$storage.$unset(path);
    }
};
u.SbSearchPill.register('sb-search-pill');

// sb-search-pill-map
(class extends u.BaseElement {
    attachedCallback() {
        super.attachedCallback();
        this.parentNode.map[this.getAttribute('canonical_name')] = this.getAttribute('display_name');
    }
}).register('sb-search-pill-map');

// sb-search-results
(class extends u.Bind {
    createdCallback() {
        this.isArchive = this.getAttribute('archive') === 'true';
    }

    attachedCallback() {
        super.attachedCallback();
    }

    $onChange(value) {
        if (!value.apps.length) {
            this.classList.add('u.hide@*');
        } else {
            this.classList.remove('u.hide@*');

            const appCards = [];
            for (let app of value.apps) {

                // Create the detailed app card
                const appCardDetailed = document.createElement('sb-app-card');
                appCardDetailed.className = "u.item:1/1@* sb.app-card";
                appCardDetailed.setAttribute("type", "detailed");
                appCardDetailed.innerHTML = `
                        <a href="/app/${app.id}">
                            <div class="u.container:nowrap@* u.container:top@* u.container:pad-little">
                                <img class="c-search-icon u.item u.icon:xl" src="${app.icon}" style="background-color: ${app.bg_color};"/>
                                <div class="u.item:grow@*">
                                    <div class="u.container">
                                        <div class="u.item:1/1@*">
                                            <div class="u.container">
                                                <h6 class="u.item">${app.name}</h6>
                                                <div class="u.item:hspace-sm" data-tooltip="Splunk Cloud" style="display:${app.cloud_compatible_static ? 'block' : 'none' }">
                                                    <svg class="u.icon sb.icon:badge">
                                                        <use xlink:href="#splunk-cloud"/>
                                                    </svg>
                                                </div>
                                                <div class="u.item:hspace-sm" data-tooltip="Built by Splunk" style="display:${app.is_splunk_built ? 'block' : 'none' }">
                                                    <svg class="u.icon sb.icon:badge">
                                                        <use xlink:href="#splunk-built"/>
                                                    </svg>
                                                </div>
                                                <div class="u.item:hspace-sm" data-tooltip="Splunk Labs" style="display:${app.is_splunk_works ? 'block' : 'none' }">
                                                    <svg class="u.icon sb.icon:badge">
                                                        <use xlink:href="#splunk-labs"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="u.item:1/1@*"><p class="sb.wrap sb.clamp:3x">${app.pitch}</p></div>
                                        <div class="u.item:1/1@*">
                                            <div class="u.container:nowrap@md-up u.container:vspace-xs@sm c-search-details-footer">
                                                <div class="u.item:1/1@sm">Released: ${app.published}</div>
                                                <div class="u.item u.hide@sm"> | </div>
                                                <div class="u.item:1/1@sm">Updated: ${app.updated}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                `;
                appCards.push(appCardDetailed);

                // Create the simple app card
                const appCardSimple = document.createElement('sb-app-card');
                if (this.isArchive) {
                    appCardSimple.className = "u.item:tall@* u.item:2/12@lg-up u.item:6/12@md-down sb.app-card";
                }else{
                    appCardSimple.className = "u.item:tall@* u.item:3/12@lg-up u.item:6/12@md-down sb.app-card";
                }
                appCardSimple.setAttribute("type", "simple");
                appCardSimple.innerHTML = `
                        <a href="/app/${app.id}">
                          <div class="u.container:pad-little">
                            <img class="u.item u.icon:xl" src="${app.icon}" style="background-color: ${app.bg_color};"/>
                            <div class="u.item:1/1@*">
                                <h6 class="sb.clamp:heading-2x">${app.name}</h6>
                            </div>
                            <div class="u.item:1/1@*">
                                <div class="u.container:repel@* u.container:middle@*">
                                    <div class="u.item">
                                        <div class="u.container">
                                            <div class="u.item:hspace-sm" data-tooltip="Splunk Cloud" style="display:${app.cloud_compatible_static ? 'block' : 'none' }">
                                                <svg class="u.icon sb.icon:badge">
                                                    <use xlink:href="#splunk-cloud"/>
                                                </svg>
                                            </div>
                                            <div class="u.item:hspace-sm" data-tooltip="Built by Splunk" style="display:${app.is_splunk_built ? 'block' : 'none' }">
                                                <svg class="u.icon sb.icon:badge">
                                                    <use xlink:href="#splunk-built"/>
                                                </svg>
                                            </div>
                                            <div class="u.item:hspace-sm" data-tooltip="Splunk Labs" style="display:${app.is_splunk_works ? 'block' : 'none' }">
                                                <svg class="u.icon sb.icon:badge">
                                                    <use xlink:href="#splunk-labs"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      </a>
                `;
                appCards.push(appCardSimple);
            }

            if (value.first === 1) {
                this.innerHTML = '';
            }

            for(let appCard of appCards) {
                this.appendChild(appCard);
            }
        }
    }
}).register('sb-search-results');

// sb-search-results
(class extends u.Consumer {
    attachedCallback() {
        super.attachedCallback();
        const button = this.querySelector('[class*="u.bt"]');
        button.addEventListener('click', this.clickfunc.bind(this));
        this.$storage.$listen('results', this.$onChange.bind(this));
    }

    clickfunc(evt) {
        evt.preventDefault();
        this.$storage.$loadMore();
    }

    $onChange(value) {
        if (value.last === value.total) {
            this.classList.add('u.hide@*');
            //click event is removed to prevent a bug from occuring
            //this.removeEventListener('click', this.clickfunc);
        } else {
            this.classList.remove('u.hide@*');
        }
    }

}).register('sb-search-loadmore');

// sb-search-feedback-container
(class extends u.Consumer {
    attachedCallback() {
        super.attachedCallback();
        this.$storage.$listen('results', this.$onChange.bind(this));
    }
    $onChange(value) {
        if (value.last !== value.total) {
            this.classList.add('u.hide@*');
        } else {
            this.classList.remove('u.hide@*');
        }
    }

}).register('sb-search-feedback-container');


// sb-search-suggestion
(class extends u.SbBind {
    attachedCallback() {
        super.attachedCallback();
        this.addEventListener('click', (evt)=> {
            evt.preventDefault();
            window.location = `/apps/#/search/${this.value}`;
        });
    }

    $onChange(value) {
        this.value = value[this.$key];
        if (this.value) {
            this.classList.remove('u.hide@*');
            this.textContent = `Show Results for "${this.value}" Instead`;
        } else {
            this.classList.add('u.hide@*');
            this.textContent = null;
        }
    }
}).register('sb-search-suggestion');

//search feedback form processing
(class extends u.ModalForm {
    attachedCallback() {
        super.attachedCallback();
        this.$findStorage();
    }

    $submit(event) {
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            if(xhr.readyState === 4) {
                if (xhr.status !== 200) {
                    this.$error("An error occurred. Please try again");
                } else {
                    this.$onSuccess();
                }
            }
        };

        this.elements.submitbtn.value = "Submitting...";

        xhr.open('POST', '/api/v0/searchfeedback/');
        xhr.setRequestHeader('X-CSRFToken', getCsrfToken());

        const formData = new FormData(this);
        formData.append('category', Object.keys(this.$storage.$get('filters|category')).join(', '));
        formData.append('search', this.$storage.$get('search'));
        formData.append('versions', Object.keys(this.$storage.$get('filters|version')).join(', '));
        formData.append('type', Object.keys(this.$storage.$get('filters|type')).join(', '));
        formData.append('cims', Object.keys(this.$storage.$get('filters|cim')).join(', '));
        formData.append('results', this.$storage.$get('results').total);

        xhr.send(formData);
    }

    $closeModal() {
        window.location.reload(false);
    }

    $findStorage() {
        // hacky but better than trying to use multi-inheritance hack
        this.$storage = null;

        let elem = this.parentElement;
        while (elem) {

            if (elem instanceof u.Storage) {
                this.$storage = elem;
            }
            elem = elem.parentElement;
        }
    }
}).register('sb-search-feedback');

window.addEventListener('WebComponentsReady', function (e) {
    for(let instance of sb.SearchStorage.instances) {
        instance.$parseURL();
    }
});

const dateFormat = {year: 'numeric', month: 'short', day: 'numeric'};
const dateLocale = 'en-US';

const product_all = "all";
const product_splunk = "splunk";
const product_soar = "soar";
const fips_compatibility = "fips_compatibility";
const splunk_built = "built";
const splunk_supported = "supported";
const includeParam = "include=icon";

const productFilters = ['product', 'product_types', 'soar_product_types'];
const productsArr = [product_splunk, product_soar];

const productMap = {
    "all": product_all,
    "enterprise": product_splunk,
    "cloud": product_splunk,
    "es": product_splunk,
    "itsi": product_splunk,
    "soar_on_prem": product_soar,
    "soar_cloud": product_soar,
}

const allTitle = document.querySelector("#all-title");
const splunkTitle = document.querySelector("#splunk-title");
const soarTitle = document.querySelector("#soar-title");

// Splunk-only filters
const splunkTechnologies = document.querySelector("#splunk-technologies");
const splunkAppType = document.querySelector("#splunk-app-type");
const splunkAppContents = document.querySelector("#splunk-app-contents");
const splunkVersion = document.querySelector("#splunk-version");
const splunkCimVersion = document.querySelector("#splunk-cim-version");
const splunkValidations = document.querySelector("#splunk-validations");
const splunkBuild = document.querySelector("#splunk-build-other")

const splunkDividers = document.querySelectorAll(".splunk-divider");
const soarDivider = document.querySelector(".soar-divider");

// UI: handle show/hide filters and dividers
function showSplunkFilters () {
    if (splunkTechnologies) splunkTechnologies.classList.remove("hide");
    if (splunkAppType) splunkAppType.classList.remove("hide");
    if (splunkAppContents) splunkAppContents.classList.remove("hide");
    if (splunkVersion) splunkVersion.classList.remove("hide");
    if (splunkCimVersion) splunkCimVersion.classList.remove("hide");
    if (splunkValidations) splunkValidations.classList.remove("hide");
    if (splunkBuild) splunkBuild.classList.remove("hide");

    for (let divider of splunkDividers){
        if (divider.classList.contains("hide"))
            divider.classList.remove("hide");
    }
}
function hideSplunkFilters () {
    if (splunkTechnologies) splunkTechnologies.classList.add("hide");
    if (splunkAppType) splunkAppType.classList.add("hide");
    if (splunkAppContents) splunkAppContents.classList.add("hide");
    if (splunkVersion) splunkVersion.classList.add("hide");
    if (splunkCimVersion) splunkCimVersion.classList.add("hide");
    if (splunkValidations) splunkValidations.classList.add("hide");
    if (splunkBuild) splunkBuild.classList.add("hide");

    for (let divider of splunkDividers){
        if (!divider.classList.contains("hide"))
            divider.classList.add("hide");
    }
}
function showSoarFilter () {
    if (soarDivider) soarDivider.classList.remove("hide");
}
function hideSoarFilters () {
    if (soarDivider) soarDivider.classList.add("hide");
}

// UI: select Products and handle filters
const updateUI = {
    allProductsSelected: () => {
        if (splunkTitle) splunkTitle.classList.remove("active");
        if (soarTitle) soarTitle.classList.remove("active");
        if (allTitle) allTitle.classList.add("active");

        hideSplunkFilters();
        hideSoarFilters();
    },
    splunkProductsSelected: () => {
        if (splunkTitle) splunkTitle.classList.add("active");
        if (soarTitle) soarTitle.classList.remove("active");
        if (allTitle) allTitle.classList.remove("active");

        hideSoarFilters();
        showSplunkFilters();
    },
    soarProductsSelected: () => {
        if (soarTitle) soarTitle.classList.add("active");
        if (splunkTitle) splunkTitle.classList.remove("active");
        if (allTitle) allTitle.classList.remove("active");

        hideSplunkFilters();
        showSoarFilter();
    }
};

function uncheckAllSubFilters (self) {
    const filters = self.$get('filters')
    for (let filter in filters){
        if (filter !== "product") {
            let subCatCount = Object.keys(filters[filter]).length;
        
            if (subCatCount > 0) {
                self.$set(`filters|${filter}`, {});
            }
        }
    }
}

function selectFilterItem (self, filterType, productTypeFilterName) {
    if (!productFilters.includes(filterType)) { // for everything but the productFilters
        self.$set(`filters|${filterType}|${productTypeFilterName}`, true);
    } else { // productFilters
        const productTypeFilterParent = productMap[productTypeFilterName];
        const products = self.$get('filters')['product'];
        for (let key in products) {
            if (key !== productTypeFilterParent && products[key]) {
                // switch between products
                self.$set(`filters|product|${key}`, false);
                uncheckAllSubFilters(self);
            }
        }
        self.$set(`filters|product|${productTypeFilterParent}`, true);
        updateUI[productTypeFilterParent+'ProductsSelected']();

        if (productsArr.includes(productTypeFilterParent)) // soar or splunk
            self.$set(`filters|${filterType}|${productTypeFilterName}`, true);
    }
    self.offset = 0;
    self.$callApi();
    self.$buildUrl();
}

function unselectFilterItem (self, filterType, productTypeFilterName) {
    if (!productFilters.includes(filterType)) { // everything but the productFilters
        self.$set(`filters|${filterType}|${productTypeFilterName}`, false);
    } else {
        const productTypeFilterParent = productMap[productTypeFilterName];
        let solutionCount = 0;

        if (productsArr.includes(productTypeFilterParent)) { // soar or splunk
            const product_types_obj = self.$get("filters")[filterType];
            for (let key in product_types_obj) {
                solutionCount = product_types_obj[key] ? solutionCount+1 : solutionCount;
            }
        }
        if (!productTypeFilterParent || solutionCount === 1) {
            uncheckAllSubFilters(self);
            self.$set(`filters|product|all`, true);
            self.$set(`filters|product|${productTypeFilterParent || productTypeFilterName}`, false);
            updateUI['allProductsSelected']();
        } else if (productTypeFilterParent === product_all) {
            uncheckAllSubFilters(self);
            self.$set(`filters|product|all`, false);
            allTitle.classList.remove("active");
        } else {
            self.$set(`filters|${filterType}|${productTypeFilterName}`, false);
        }
    }
    self.offset = 0;
    self.$callApi();
    self.$buildUrl();
}

// sb-search-storage-v2-1
sb.SearchStorageV2 = class extends u.Storage {
    createdCallback() {
        this.isArchive = this.getAttribute('archive') === 'true';
        localStorage.clear();
    }

    attachedCallback() {
        super.attachedCallback();

        this._lastQuery = '';
        this.isRefreshDisabled = false;
        this.offset = 0;

        this.$set('results', []);
        this.$set('viewType', 'simple');

        this.$listen('search', this.$changeFilter.bind(this));
        this.$listen('order', this.$changeFilter.bind(this));

        window.addEventListener('hashchange', this.$parseURL.bind(this));
        sb.SearchStorageV2.instances.push(this);
    }

    $callApi() {
        if (!this.isRefreshDisabled) {
            const queries = this.$buildQuery();
            this._lastQuery = queries.queryString;
            const resultString = localStorage.getItem(queries.queryString);

            if (resultString) {
                const result = JSON.parse(resultString);
                this.$set('results', result);
                this.offset = result.last;
                this.$sendGoogleAnalytics(queries.loggedQueries, this.offset, result.total);
            }

            else {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', `/api/v2/apps/?${includeParam}&${queries.queryString}`);
                xhr.onload = () => {
                    if (xhr.readyState === 4 && queries.queryString === this._lastQuery) {
                        const result = JSON.parse(xhr.responseText);
                        // calculate X in "Showing 1-X of Y results"
                        if ((result.offset + result.limit) > result.total) {
                            result.last = result.total; // this is the last page of results
                        } else {
                            result.last = result.offset + result.limit; // there are more results after this page
                        }
                        this.$set('results', result);
                        localStorage.setItem(queries.queryString, JSON.stringify(result));
                        this.offset = result.last;
                        this.$sendGoogleAnalytics(queries.loggedQueries, this.offset, result.total);
                    }
                };
                xhr.send();
            }
        }
    }

    $changeFilter() {
        if (!this.isRefreshDisabled) {
            this.offset = 0;
            this.$callApi();
            this.$buildUrl();
        }
    }

    $loadMore() {
        this.$enableRefresh();
        this.$callApi();
    }

    $disableRefresh() {
        this.isRefreshDisabled = true;
    }

    $enableRefresh() {
        this.isRefreshDisabled = false;
    }

    $sendGoogleAnalytics(queries, offset, total) {
        // Only send under certain circumstances...
        // offset === 0: this is the first search - not subsequent searches due to pagination
        // "search" in queries: user searched for a string. Don't send if they just used filters with no search string
        if (offset === 0 && "search" in queries) {
            // sort queries by key ("search", "products", etc) so it's organized properly in google analytics
            let sorted = [];
            for (let key in queries) {
                sorted[sorted.length] = key;
            }
            sorted.sort();

            // put the sorted queries into a human readable string
            let searchParams = [];
            for (let key in sorted) {
                searchParams.push(sorted[key] + '=' + queries[sorted[key]]);
            }
            const joined_params = searchParams.join(', ');
            _gaq.push(['_trackEvent', 'Search', 'apps', joined_params, total]);
        }
    }

    $parseURL() {
        /**
         * when a page is first loaded or the url changes, we must parse the URL to pre-fill the filters
         * based on the fragment
         *
         * TODO(bchoi): change the frag to browser history in the future
         */

        // this.$set() fires callapi. We want to fire callApi when we are all done loading the filters based on
        // the url fragments
        this.$disableRefresh();

        this.$clearFilters();
        const hashes = window.location.hash.split('/');
        let productValue;

        for (let i = 1; i < hashes.length; i += 2) {
            let filterType = hashes[i],
                value = decodeURIComponent(hashes[i + 1]);
            // Escape value to prevent XSS
            value = value.replace(/&/g, '').replace(/</g, '').replace(/>/g, '').replace(/"/g, '').replace(/'/g, '').replace(/\//g, '');
            
            if (filterType && value) {
                if (filterType in this.$get('filters')) {
                    let values = value.split(',');
                    for (let value of values) {
                        this.$set('filters|' + filterType + '|' + value, true);
                        if (filterType === "product"){
                            productValue = value;
                            updateUI[productValue+'ProductsSelected']();
                        }
                    }
                } else {
                    this.$set(filterType, value, true);
                }
            }
        }
        this.$enableRefresh();

        // display All Products if url doesn't contain a query.
        if (!productValue)
            selectFilterItem(this, "product", product_all);
        else {
            this.offset = 0;
            this.$callApi();
        }
    }

    $buildQuery() {
        let queries = [];
        let loggedQueries = {}; // for google analytics

        const search = this.$get('search');
        let order = this.$get('order');
        let options = {};

        options.relevance = document.getElementById('sortrelevance'); 
        options.latest = document.getElementById('sortlatest');
        options.popular = document.getElementById('sortpopular');

        queries.push(`offset=${this.offset}`);

        options.relevance.removeAttribute('selected');
        options.latest.removeAttribute('selected');
        options.popular.removeAttribute('selected');

        // if keyword search is in place, we need to take care of some logistics
        if (search) {
            // If there's a search, enable/show the relevance sort option
            options.relevance.disabled = false;
            options.relevance.classList.remove("u.hide@*");

            queries.push(`query=${search}`);
            loggedQueries['search'] = search.toLowerCase();

            // if no order is selected, go with relevance order by default
            if (!order) {
                queries.push('order=relevance');
                options.relevance.selected = true;
            } else {
                queries.push(`order=${order}`);
                options[order].selected = true;
            }
        } else {

            // If there's no search, disable/hide the relevance sort option
            // this won't hide it in all browsers, hence disabling too
            options.relevance.classList.add("u.hide@*"); 
            options.relevance.disabled = true;

            // if no order is selected, go with newest order by default
            if (!order) {
                queries.push('order=latest');
                options.latest.selected = true;
            } else {
                queries.push(`order=${order}`);
                options[order].selected = true;
            }
            if (this.isArchive) {
                options.latest.selected = false;
                options.popular.selected = true;
                queries.push('order=popular');
            }
        }

        if (this.isArchive) {
            queries.push('archive=true');
        }else{
            queries.push('archive=false');
        }

        const obj = this.$get('filters');
        for (let filter in obj) {
            let filters = [];
            for (let item in obj[filter]) {
                if (obj[filter][item] === true) {
                    filters.push(item);
                }
            }
            if (filters.length > 0) {
                if (filter == "validation" || filter == "status") {
                    for (let ele of filters) {
                        if (ele == fips_compatibility) {
                            queries.push(`${ele}=true`);
                            loggedQueries[ele] = "true";
                        }
                        if (ele == splunk_built) {
                            queries.push("created_by=splunk");
                            loggedQueries["created_by"] = "splunk";
                        }
                        if (ele == splunk_supported) {
                            queries.push("support=splunk");
                            loggedQueries["support"] = "splunk";
                        }
                    }
                } else if (filter == 'author') {
                    queries.push(`created_by=${filters.join(',')}`)
                    loggedQueries['created_by'] = filters.join(',');
                } else if (filter == 'soar_product_types') { // soar product type params/values are different in the api
                    // in the API the soar on-prem product type is just called "soar", so we have to rename it
                    for (let i = 0; i < filters.length; i++) {
                        if (filters[i] == 'soar_on_prem') {
                            filters[i] = 'soar';
                            break;
                        }
                    }
                    queries.push(`product_types=${filters.join(',')}`)
                } else {
                    queries.push(`${filter}=${filters.join(',')}`)
                    loggedQueries[filter] = filters.join(',');
                }
            }
        }

        return {queryString:queries.join('&'), loggedQueries:loggedQueries};
    }

    $buildUrl() {
        let params = [];

        const order = this.$get('order');
        if(order) {
            params.push(`order/${order}`);
        }

        const search = this.$get('search');
        if (search) {
            // URL encode the search keywords
            const uriSearch = encodeURI(search);
            // put the search keywords into the URL
            params.push(`search/${uriSearch}`);
        }

        const obj = this.$get('filters');
        for (let filter of Object.keys(obj)) {
            let filters = [];
            for (let item of Object.keys(obj[filter])) {
                if (obj[filter][item] === true) {
                    filters.push(item);
                }
            }
            if (filters.length > 0) {
                params.push(`${filter}/${filters.join(',')}`)
            }
        }
        history.pushState(null, null, '#/' + params.join('/'));
    }
    
    $clearFilters() {
        this.$set('filters', {});
        this.$set('filters|product', {});
        this.$set('filters|product_types', {});
        this.$set('filters|soar_product_types', {});
        this.$set('filters|categories', {});
        this.$set('filters|technology', {});
        this.$set('filters|app_type', {});
        this.$set('filters|content', {});
        this.$set('filters|versions', {});
        this.$set('filters|cim_versions', {});
        this.$set('filters|status', {});
        this.$set('filters|author', {});
        this.$set('filters|archive', {});
        this.$set('filters|validation', {});
        this.$set('order', '');
        this.$set('search', '');
        this.$set('offset', 0);
    }
}

sb.SearchStorageV2.instances = [];
sb.SearchStorageV2.register('sb-search-storage-v2-1');


// sb-search-toggle-v2-1
u.SearchToggle = class extends u.BaseElement {
    attachedCallback() {
        const group = this.getAttribute('group');
        if (!u.SearchToggle.groups.hasOwnProperty(group)) {
            u.SearchToggle.groups[group] = [];
        }

        u.SearchToggle.groups[group].push(this);

        super.attachedCallback();
        this.addEventListener('click', () => {
            this.classList.toggle('open');
            for (let toggle of u.SearchToggle.groups[group]) {
                if (toggle !== this) {
                    toggle.classList.remove('open');
                }
            }
        });
    }
};
u.SearchToggle.groups = {};
u.SearchToggle.register('sb-search-toggle-v2-1');

// sb-filter-count-v2-1
(class extends u.Bind {
    $onChange(value) {
        let count = 0;
        for (let key of Object.keys(value)) {
            if (value[key]) {
                count++;
            }
        }

        if (count) {
            this.textContent = count;
            this.classList.add('show');
        } else {
            this.classList.remove('show');
        }
    }
}).register('sb-filter-count-v2-1');

// sb-search-checkbox-v2-1
(class extends u.ConsumerInput {
    attachedCallback() {
        super.attachedCallback();
        this.searchfield = this.getAttribute('searchfield');
        if (this.searchfield !== null) {
            this.searchfield = this.getAttribute('searchfield');
            this.parentPath = `filters|${this.searchfield}`;
        } else {
            this.parentPath = `filters|${this.name}`;
        }
        this.path = `${this.parentPath}|${this.value}`;

        this.$storage.$listen(this.path, this.$onChange.bind(this));
        this.$storage.$listen(this.parentPath, this.$onClear.bind(this));

        this.addEventListener('change', () => {
            if (this.checked)
                selectFilterItem(this.$storage, this.name, this.value);
            else 
                unselectFilterItem(this.$storage, this.name, this.value);
        });
    }

    $onChange(value) {
        this.checked = value;
    }

    // when filters are being cleared, we need to make sure all of checkboxes get cleared too.
    $onClear(value) {
        if (Object.keys(value).length === 0) {
            this.checked = false;
        }
    }
}).register('sb-search-checkbox-v2-1');

// sb-search-pill-v2-1
u.SbSearchPill = class extends u.Bind {
    attachedCallback() {
        super.attachedCallback();

        // canonical to display name map filled by sb-search-pill-map
        this.map = {};
        this.name = this.getAttribute('name');
    }

    $name(value) {
        // if the mapping exists, use it otherwise return the value as is
        if (value in this.map) {
            return this.map[value];
        }
        return value;
    }

    $onChange(value) {
        this.innerHTML = '';

        if (!value || value === undefined || value.length === 0) {
            return;
        }

        const self = this;
        const filters = [];

        if (typeof(value) === 'object') {
            for (let filter of Object.keys(value)) {
                if (value[filter]) {
                    filters.push({
                        name: this.$name(filter),
                        path: self.bindTo + "|" + filter
                    });
                }
            }
        } else {
            filters.push({
                name: this.$name(value),
                path: self.bindTo
            });
        }

        for (let filter of filters) {
            const button = document.createElement('button');
            button.className = "u.btn u.item c-search-pill";
            button.addEventListener('click', ()=> {
                self.$onRemove(filter.path);
            });

            const nameSpan = document.createElement('span');
            nameSpan.innerHTML = `${this.name}: `;

            // name:
            button.appendChild(nameSpan);

            const span = document.createElement('span');
            span.innerHTML = filter.name;

            const remove = document.createElement('span');
            remove.className = 'remove';
            remove.innerHTML = "<svg class='u.icon:tiny sb.color:gray-dark c-search-pill__close'><use xlink:href='#close-x'/></svg>";

            button.appendChild(span);
            button.appendChild(remove);
            this.appendChild(button);
        }
    }

    $onRemove(path) {
        if (path === 'search')
            this.$storage.$unset(path);
        else
            unselectFilterItem(this.$storage, path.split('|')[1], path.split('|')[2]);
    }
};
u.SbSearchPill.register('sb-search-pill-v2-1');

// sb-bind-v2-1
u.SbBind = class extends u.Bind {
    attachedCallback() {
        super.attachedCallback();
        this.$key = this.getAttribute('bind-key');
    }
    $onChange(value) {
        super.$onChange(value[this.$key]);
    }
};
u.SbBind.register('sb-bind-v2-1');

// sb-results-v2-1
(class extends u.Bind {
    attachedCallback() {
        super.attachedCallback();
        this.$key = this.getAttribute('bind-key');
    }
    $onChange(value) {
        // message for no results returned
        const no_results = document.querySelector('p[is=sb-no-results]');
        // hide sort select if no results returned
        const sort_select = document.querySelector('select[is=order-select-v2-1]');

        if (value[this.$key] > 0) {
            no_results.classList.add('u.hide@*');
            sort_select.classList.remove('u.hide@*');
            this.classList.remove('u.hide@*');
        } else {
            no_results.classList.remove('u.hide@*');
            sort_select.classList.add('u.hide@*');
            this.classList.add('u.hide@*');
        }
    }
}).register('sb-results-v2-1');

// sb-search-input-v2-1
// TODO is this used?
// (class extends u.ConsumerInput {
//     attachedCallback() {
//         super.attachedCallback();
//         this.addEventListener('change', ()=> {
//             if (this.value) {
//                 this.$storage.$set('search', this.value);
//             } else {
//                 this.$storage.$set('search', '');
//             }
//         });
//     }
// }).register('sb-search-input-v2-1');

// sb-archive-search-input-v2-1
(class extends u.ConsumerInput {
    attachedCallback() {
        super.attachedCallback();
        this.addEventListener('change', ()=> {
            if (this.value) {
                this.$storage.$set('search', this.value);
            } else {
                this.$storage.$set('search', '');
            }
        });
    }
}).register('sb-archive-search-input-v2-1');

// order-select-v2-1
(class extends u.ConsumerSelect {
    attachedCallback() {
        super.attachedCallback();

        this.path = `${this.name}`;

        this.$storage.$listen(this.path, this.$onChange.bind(this));

        this.addEventListener('change', ()=> {
            this.$storage.$set('order', this.value);
        });
    }

    $onChange(value) {
        this.value = value;
    }
}).register('order-select-v2-1');

// sb-view-toggle-v2-1
// toggle for details vs. simple view
sb.SearchViewToggle = class extends u.Consumer {
    attachedCallback() {
        super.attachedCallback();

        this.viewType = this.getAttribute('type');
        sb.SearchViewToggle.items.push(this);

        this.addEventListener('click', ()=> {
            this.$storage.$set('viewType', this.viewType);

            // update button colors
            for (let i = 0; i < sb.SearchViewToggle.items.length; i++) {
                if (sb.SearchViewToggle.items[i].getAttribute('type') === this.viewType) {
                    sb.SearchViewToggle.items[i].firstElementChild.classList.add('active');
                } else {
                    sb.SearchViewToggle.items[i].firstElementChild.classList.remove('active');
                }
            }
        });
    }
};
sb.SearchViewToggle.items = [];
sb.SearchViewToggle.register('sb-view-toggle-v2-1');

// sb-app-card-v2-1
sb.AppCard = class extends u.Consumer {
    attachedCallback() {
        super.attachedCallback();
        this.type = this.getAttribute('type');
        this.$storage.$listen('viewType', this.$onChange.bind(this))

        // toggle based on the initial state when being added
        this.$onChange(this.$storage.$get('viewType'));
    }

    $onChange(value) {
        if(this.type === value) {
            this.classList.remove("u.hide@*");
        } else {
            this.classList.add("u.hide@*");
        }
    }
};
sb.AppCard.register('sb-app-card-v2-1');
sb.AppCard.appCardsDetailed = [];
sb.AppCard.appCardsSimple = [];


// sb-search-pill-map-v2-1
(class extends u.BaseElement {
    attachedCallback() {
        super.attachedCallback();
        this.parentNode.map[this.getAttribute('canonical_name')] = this.getAttribute('display_name');
    }
}).register('sb-search-pill-map-v2-1');

// sb-search-results-v2-1
(class extends u.Bind {
    createdCallback() {
        this.isArchive = this.getAttribute('archive') === 'true';
    }

    attachedCallback() {
        super.attachedCallback();
    }

    $onChange(value) {
        if (!value.results || value.results.length === 0) {
            this.classList.add('u.hide@*');
        } else {
            this.classList.remove('u.hide@*');

            const appCards = [];
            for (let app of value.results) {
                const published_date = new Date(Date.parse(app.published_time)).toLocaleDateString(dateLocale, dateFormat);
                const updated_date = new Date(Date.parse(app.updated_time)).toLocaleDateString(dateLocale, dateFormat);

                // Create the detailed app card
                const appCardDetailed = document.createElement('sb-app-card-v2-1');
                appCardDetailed.className = "u.item:1/1@* sb.app-card";
                appCardDetailed.setAttribute("type", "detailed");
                let product_name = '';
                if (app.product_compatibility == 'soar') {
                    product_name = 'Splunk SOAR'
                } else if (app.product_compatibility == 'splunk') {
                    product_name = 'Splunk'
                }
                appCardDetailed.innerHTML = `
                        <a href="/app/${app.id}">
                            <div class="u.container:top@* u.container:pad-little">
                                <img class="c-search-icon u.item u.icon:xl" src="${app.icon}" style="background-color: ${app.bg_color};"/>
                                <div class="u.item:grow@*" style="width:70%;">
                                    <div class="u.container">
                                        <div class="u.item:1/1@*">
                                            <div class="u.container">
                                                <h6 class="u.item">${app.app_name}</h6>
                                                <div class="u.item:hspace-sm" data-tooltip="${product_name} Cloud" style="display:${app.cloud_compatible ? 'block' : 'none' }">
                                                    <svg class="u.icon sb.icon:badge">
                                                        <use xlink:href="#splunk-cloud"/>
                                                    </svg>
                                                </div>
                                                <div class="u.item:hspace-sm" data-tooltip="Built by Splunk" style="display:${app.is_splunk_built ? 'block' : 'none' }">
                                                    <svg class="u.icon sb.icon:badge">
                                                        <use xlink:href="#splunk-built"/>
                                                    </svg>
                                                </div>
                                                <div class="u.item:hspace-sm" data-tooltip="Splunk Labs" style="display:${app.is_splunk_works ? 'block' : 'none' }">
                                                    <svg class="u.icon sb.icon:badge">
                                                        <use xlink:href="#splunk-labs"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="u.item:1/1@*"><p class="sb.wrap sb.clamp:3x">${app.description}</p></div>
                                        <div class="u.item:1/1@*">
                                            <div class="u.container:nowrap@md-up u.container:vspace-xs@sm c-search-details-footer">
                                                <div class="u.item:1/1@sm">Released: ${published_date}</div>
                                                <div class="u.item u.hide@sm"> | </div>
                                                <div class="u.item:1/1@sm">Updated: ${updated_date}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="u.item u.btn:wide@xs sb.pill-tag no-hover ${app.product_compatibility} search-page-detail-view">${app.product_compatibility}</div>
                            </div>
                        </a>
                `;
                appCards.push(appCardDetailed);

                // Create the simple app card
                const appCardSimple = document.createElement('sb-app-card-v2-1');
                if (this.isArchive) {
                    appCardSimple.className = "u.item:tall@* u.item:2/12@lg-up u.item:6/12@md-down sb.app-card";
                }else{
                    appCardSimple.className = "u.item:tall@* u.item:3/12@lg-up u.item:6/12@md-down sb.app-card";
                }
                appCardSimple.setAttribute("type", "simple");
                appCardSimple.innerHTML = `
                        <a href="/app/${app.id}">
                          <div class="u.container:pad-little">
                            <div class="u.item:1/1@*">
                                <div class="u.container:repel@* u.container:top@*">
                                    <img class="u.item u.icon:xl" src="${app.icon}" style="background-color: ${app.bg_color};"/>
                                    <div class="u.item u.btn:wide@xs sb.pill-tag no-hover ${app.product_compatibility}">${app.product_compatibility}</div>
                                </div>
                            </div>
                            <div class="u.item:1/1@*">
                                <h6 class="sb.clamp:heading-2x">${app.app_name}</h6>
                            </div>
                            <div class="u.item:1/1@*">
                                <div class="u.container:repel@* u.container:middle@*">
                                    <div class="u.item">
                                        <div class="u.container">
                                            <div class="u.item:hspace-sm" data-tooltip="${product_name} Cloud" style="display:${app.cloud_compatible ? 'block' : 'none' }">
                                                <svg class="u.icon sb.icon:badge">
                                                    <use xlink:href="#splunk-cloud"/>
                                                </svg>
                                            </div>
                                            <div class="u.item:hspace-sm" data-tooltip="Built by Splunk" style="display:${app.is_splunk_built ? 'block' : 'none' }">
                                                <svg class="u.icon sb.icon:badge">
                                                    <use xlink:href="#splunk-built"/>
                                                </svg>
                                            </div>
                                            <div class="u.item:hspace-sm" data-tooltip="Splunk Labs" style="display:${app.is_splunk_works ? 'block' : 'none' }">
                                                <svg class="u.icon sb.icon:badge">
                                                    <use xlink:href="#splunk-labs"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      </a>
                `;
                appCards.push(appCardSimple);
            }
            if (value.offset === 0) {
                this.innerHTML = '';
            }

            
            for(let appCard of appCards) {
                this.appendChild(appCard);
            }
        }
    }
}).register('sb-search-results-v2-1');

// sb-search-loadmore-v2-1
(class extends u.Consumer {
    attachedCallback() {
        super.attachedCallback();
        const button = this.querySelector('div[id="loadmore"]');
        button.addEventListener('click', this.clickfunc.bind(this));
        this.$storage.$listen('results', this.$onChange.bind(this));
    }

    clickfunc(evt) {
        evt.preventDefault();
        this.$storage.$loadMore();
    }

    $onChange(value) {
        if (value.last === value.total) {
            this.classList.add('u.hide@*');
            //click event is removed to prevent a bug from occuring
            //this.removeEventListener('click', this.clickfunc);
        } else {
            this.classList.remove('u.hide@*');
        }
    }

}).register('sb-search-loadmore-v2-1');

// sb-search-feedback-container-v2-1
(class extends u.Consumer {
    attachedCallback() {
        super.attachedCallback();
        this.$storage.$listen('results', this.$onChange.bind(this));
    }
    $onChange(value) {
        if (value.last !== value.total) {
            this.classList.add('u.hide@*');
        } else {
            this.classList.remove('u.hide@*');
        }
    }

}).register('sb-search-feedback-container-v2-1');


// sb-search-suggestion-v2-1
(class extends u.SbBind {
    attachedCallback() {
        super.attachedCallback();
        this.addEventListener('click', (evt)=> {
            evt.preventDefault();
            window.location = `/apps/#/search/${this.value}`;
        });
    }

    $onChange(value) {
        this.value = value[this.$key];
        if (this.value) {
            this.classList.remove('u.hide@*');
            this.textContent = `Show Results for "${this.value}" Instead`;
        } else {
            this.classList.add('u.hide@*');
            this.textContent = null;
        }
    }
}).register('sb-search-suggestion-v2-1');

// sb-search-feedback-v2-1
//search feedback form processing
(class extends u.ModalForm {
    attachedCallback() {
        super.attachedCallback();
        this.$findStorage();
    }

    $submit(event) {
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            if(xhr.readyState === 4) {
                if (xhr.status !== 200) {
                    this.$error("An error occurred. Please try again");
                } else {
                    this.$onSuccess();
                }
            }
        };

        this.elements.submitbtn.value = "Submitting...";

        xhr.open('POST', '/api/v0/searchfeedback/');
        xhr.setRequestHeader('X-CSRFToken', getCsrfToken());

        const formData = new FormData(this);
        formData.append('category', Object.keys(this.$storage.$get('filters|category')).join(', '));
        formData.append('search', this.$storage.$get('search'));
        formData.append('versions', Object.keys(this.$storage.$get('filters|version')).join(', '));
        formData.append('type', Object.keys(this.$storage.$get('filters|type')).join(', '));
        formData.append('cims', Object.keys(this.$storage.$get('filters|cim')).join(', '));
        formData.append('results', this.$storage.$get('results').total);

        xhr.send(formData);
    }

    $closeModal() {
        window.location.reload(false);
    }

    $findStorage() {
        // hacky but better than trying to use multi-inheritance hack
        this.$storage = null;

        let elem = this.parentElement;
        while (elem) {

            if (elem instanceof u.Storage) {
                this.$storage = elem;
            }
            elem = elem.parentElement;
        }
    }
}).register('sb-search-feedback-v2-1');

window.addEventListener('WebComponentsReady', function (e) {
    for(let instance of sb.SearchStorageV2.instances) {
        instance.$parseURL();
    }
});
/**
 * Homepage technology carousel
 */

sb.TechCarousel = class extends u.Carousel {
    attachedCallback() {
        super.attachedCallback();
        this._link = document.querySelector('#sb-tech-link');
    }
    $onChange() {
        const elem = this.firstElementChild.children[this._index];
        this._link.setAttribute('href', '/apps/#/technology/' + elem.dataset.tech);
        this._link.innerHTML = `See all ${elem.dataset.name} apps &#x203a;`;
    }
};
sb.TechCarousel.register('sb-tech-carousel');


/**
 * Homepage technology icons
 */

sb.TechIcon = class extends SVGElement {

    static updateStyles(idx) {

        if (sb.TechIcon.active !== null) {
            sb.TechIcon.items[sb.TechIcon.active].parentNode.classList.remove(sb.TechIcon.activeClass);
        }
        sb.TechIcon.items[idx].parentNode.classList.add(sb.TechIcon.activeClass);
        sb.TechIcon.active = idx;
    }

    attachedCallback() {

        sb.TechIcon.items.push(this);
        this._index = this.getAttribute('data-index');

        if (this.parentNode.classList.contains(sb.TechIcon.activeClass)) {
            sb.TechIcon.active = this._index;
        }

        this.$carousels = [
            document.querySelector('#technology-apps'),
            document.querySelector('#technology-icons')
        ];

        this.addEventListener('click', () => {
            // update icon styles (if it wasn't a mobile arrow that was clicked)
            if (this.elementType != 'sb-tech-move') {
                sb.TechIcon.updateStyles(parseInt(this._index));
                this.parentNode.classList.add(sb.TechIcon.activeClass);
            }
            // move carousel to correct item
            this.$carousels.forEach((elem) => {
                elem.$moveTo(this._index);
            });
        });        
    }
};

sb.TechIcon.active = null;
sb.TechIcon.items = [];
sb.TechIcon.activeClass = 'active';

document.registerElement('sb-tech-icon', {
    prototype: sb.TechIcon.prototype,
    extends: 'svg'
});

/**
 * Homepage technology arrows
 */

sb.TechMove = class extends HTMLElement {

    attachedCallback() {
        this._to = this.getAttribute('u-to');

        this.$carousels = [
            document.querySelector('#technology-apps'),
            document.querySelector('#technology-icons')
        ];

        this.addEventListener('click', () => {
            let index = null;
            this.$carousels.forEach((elem) => {
                index = elem.$moveTo(this._to);
            });
            sb.TechIcon.updateStyles(index);
        });
    }
};

document.registerElement('sb-tech-move', {
    prototype: sb.TechMove.prototype
});

// sb-search-storage
sb.DetailsStorage = class extends u.Storage {
    attachedCallback() {
        super.attachedCallback();
        sb.DetailsStorage.instances.push(this);
    }

    $init() {
        this.$set('appRateAverage', this.getAttribute('sb-app-rate-average'));
        this.$set('appRateReviewCount', this.getAttribute('sb-app-rate-review-count'));
        this.$set('appRateByUser', this.getAttribute('sb-app-rate-by-user'));
        this.$set('originalRating', this.getAttribute('sb-app-rate-by-user'));
        this.$set('starHover', -1);
    }
}
sb.DetailsStorage.instances = [];
sb.DetailsStorage.register('sb-details-storage');

sb.ReleaseSelect = class extends u.ForElement {
    attachedCallback() {
        super.attachedCallback();

        this.selectorElement = document.getElementById(this.getAttribute('sb-selector'));
        this.selectorElement.addEventListener('change', (evt) => {
            this.$onChange();
        });

        this.target = this.getAttribute('sb-target');
        this.href = this.getAttribute('sb-href');

        this.$onChange();
    }

    $onChange() {
        if (this.selectorElement.value === this.target) {
            this.classList.remove('u.hide@*');
        } else {
            this.classList.add('u.hide@*');
        }
    }
};
sb.ReleaseSelect.register('sb-release-select');

(class extends sb.ReleaseSelect {
    attachedCallback() {
        super.attachedCallback();

        this.addEventListener('click', (evt) => {
            evt.preventDefault();
            evt.stopPropagation();

            // a hack warning: we need to pass the download link
            // to <form is="sb-details-agree"> and #download-modal is the only
            // elements they share
            this.$forElement._href = this.href;
            this.$forElement.$toggle();
        });
    }

}).register('sb-release-select-click');

(class extends u.BaseForm {
    attachedCallback() {
        super.attachedCallback();

        this._agree = this.querySelector('#agree');
        this._download = this.querySelector('#download');

        const id = this.getAttribute('u-for');
        if(id) {
            this.$forElement = document.getElementById(id);
            this.$forElement.addEventListener('u-modal-open', this.$open.bind(this));
        }
        this._handler = null;
    }

    $open() {
        this.reset();
        if (this._handler) {
            this.removeEventListener('submit', this._handler);
        }

        this._handler = this.$download.bind(this);
        this.addEventListener('submit', this._handler);

        this._agree.classList.remove('u.hide@*');
        this._download.classList.add('u.hide@*');
    }

    $close(evt) {
        evt.preventDefault();
        this.$forElement.$close();
    }

    $download(evt) {
        evt.preventDefault();
        const lead = this.elements["download-lead"].checked;
        const agreeElm = this.elements["download-agree"];

        // BASE-3937 - hack for Safari
        if(agreeElm.checked===true){
            window.location = this.$forElement._href + "?origin=asc&lead=" + lead;
            this._agree.classList.add('u.hide@*');
            this._download.classList.remove('u.hide@*');

            this.removeEventListener('submit', this._handler);

            this._handler = this.$close.bind(this);
            this.addEventListener('submit', this._handler);
        } else {
            // this will only fire in browsers that do not support HTML5 validation
            alert('Please agree to the terms and conditions by clicking the first checkbox.');
        }
    }

}).register('sb-details-agree');

// flag as inappropriate form processing
(class extends u.ModalForm {

    attachedCallback() {
        super.attachedCallback();

    }

    $submit(event) {
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            if(xhr.readyState === 4) {
                if (xhr.status !== 200) {
                    this.$error("An error occurred. Please try again");
                } else {
                    this.$onSuccess();
                }
            }
        };

        this.elements.submitbtn.value = "Submitting...";

        const formData = new FormData(this);

        xhr.open('POST', `/api/v0/app/${context.appid}/flag/`);
        xhr.setRequestHeader('X-CSRFToken', getCsrfToken());
        xhr.send(formData);
    }

}).register('sb-flag-inappropriate');

(class extends u.Consumer {
    attachedCallback() {
        super.attachedCallback();
        this.$storage.$listen("appRateButtonOn", this.$toggle.bind(this));
    }

    $toggle(value) {
        if (this.classList.contains('open')) {
            this.classList.remove('open');
        } else {
            this.classList.add('open');
        }
    }
}).register('sb-details-star');

(class extends u.Bind {
    attachedCallback() {
        super.attachedCallback();
        this.stars = this.children;
        const clickDisabled = this.getAttribute('sb-click-disabled');

        if (clickDisabled !== "true") {
            for(let i=0; i<this.stars.length; i++) {
                this.stars[i].addEventListener('mouseenter', (evt)=>{
                    this.$mouseenter(i);
                });

                this.stars[i].addEventListener('mouseleave', (evt)=>{
                    this.$mouseleave(i);
                });

                this.stars[i].addEventListener('click', (evt)=>{
                    this.$click(i);
                });
            }
        }
    }

    $click(index) {
        const rating = index + 1;
        const xhr = new XMLHttpRequest();
        const self = this;

        xhr.open('POST', `/api/v0/app/${context.appid}/review/`);
        xhr.onload = () => {
            if (xhr.readyState === 4) {
                const result = JSON.parse(xhr.responseText);
                self.$storage.$set('appRateAverage', result.value);
                self.$storage.$set('appRateReviewCount', result.count);
                self.$storage.$set('appRateByUser', rating);
                self.$storage.$set('appRateButtonOn', false);

                // google analytics
                if (self.$storage.$get('originalRating') === 0) {
                    _gaq.push(['_trackEvent', 'Star-rating', 'rated', String(context.appid), rating]);
                } else {
                    _gaq.push(['_trackEvent', 'Star-rating', 'updated', String(context.appid), rating]);
                }
            }
        };

        var params = `rating=${rating}`;
        xhr.setRequestHeader("X-CSRFToken", getCsrfToken());
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.send(params);
    }

    $onChange(average) {
        for(let i=0; i<this.stars.length; i++) {
            if (i < average) {
                this.stars[i].classList.add('highlighted');
            } else {
                this.stars[i].classList.remove('highlighted');
            }
        }
    }

    $mouseenter(index) {
        for(let i=0; i<this.stars.length; i++) {
            this.stars[i].classList.add('shadow');
            if(i === index) {
                break;
            }
        }
        this.$storage.$set('starHover', index);
    };

    $mouseleave(index) {
        for(let i=0; i<this.stars.length; i++) {
            this.stars[i].classList.remove('shadow');

            if(i === index) {
                break;
            }
        }
        this.$storage.$set('starHover', -1);
    };
}).register('sb-details-star-buttons');

sb.DetailsStarAnnotation = class extends u.Consumer {
    attachedCallback() {
        super.attachedCallback();
        this.$storage.$listen("appRateByUser", this.$reset.bind(this));
        this.$storage.$listen("starHover", this.$onHover.bind(this));
    }

    $reset(value) {
        let msg = 'You did not rate this app';
        if(value==1){ 
            msg = `You rated this app ${value} star`;
        } else if(value>1){
            msg = `You rated this app ${value} stars`;
        }
        this.innerHTML = msg;
    }

    $onHover(value) {
        if (value >= 0) {
            this.innerHTML = sb.DetailsStarAnnotation.annotation[value];
        } else {
            this.$reset(this.$storage.$get("appRateByUser"));
        }
    }
};

sb.DetailsStarAnnotation.annotation = {
    0: "Doesn't work as expected",
    1: "Works but unstable",
    2: "Works but needs improvement",
    3: "Works as expected",
    4: "Exceeds expectations"
};
sb.DetailsStarAnnotation.register('sb-details-star-annotation');

(class extends u.Bind {
    $onChange(value) {
        if (value > 1) {
            this.textContent = `${value} ratings`;
        } else {
            this.textContent = `${value} rating`;
        }
    }
}).register('sb-details-star-review-count');

(class extends u.BaseElement {
    attachedCallback() {
        super.attachedCallback();

        this.addEventListener('click', (evt) => {
            this.action = this.getAttribute('data-value');

            const xhr = new XMLHttpRequest();
            xhr.open('POST', `/api/v0/app/${context.appid}/subscription/`);

            var params = `action=${this.action}`;
            xhr.setRequestHeader("X-CSRFToken", getCsrfToken());
            xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=UTF-8");
            xhr.send(params);

            xhr.onload = () => {
                if (xhr.readyState === 4 && xhr.status === 204) {
                    var subscribe_buttons = document.getElementsByTagName('sb-subscribe-button');
                    if (this.action === 'subscribe') {
                        for (var i = 0; i < subscribe_buttons.length; i++) {
                            subscribe_buttons[i].setAttribute('data-value', 'unsubscribe');
                            subscribe_buttons[i].textContent = 'Unsubscribe';
                        }
                    } else if (this.action === 'unsubscribe') {
                        for (var i = 0; i < subscribe_buttons.length; i++) {
                            subscribe_buttons[i].setAttribute('data-value', 'subscribe');
                            subscribe_buttons[i].textContent = 'Subscribe';
                        }
                    }
                }
            };
        });
    }
}).register('sb-subscribe-button');

(class extends u.BaseElement {
    // controls youtube iframe on an event
    //
    // on: specify an event in id:event. multiple events can be listed with space in between
    // action: choose an action (name of a function name of the youtube API)

    createdCallback() {
        super.createdCallback();
        const events = this.getAttribute('on').split(' ');
        this.action = this.getAttribute('action');
        this.player = null;
        this.isPlayerReady = false;
        for (let event of events) {
            const eventPair = event.split(':');
            const targetID = eventPair[0];
            const eventName = eventPair[1];
            const element = document.getElementById(targetID);
            element.addEventListener(eventName, this.handler.bind(this));
        }
    }

    handler() {
        // we can't construct YT object during createdCallback time because
        // the dom is not fully constructed at that point
        if(!this.player) {
            this.player = new YT.Player(this.firstElementChild.id, {
                events: {
                    'onReady': this.onPlayerReady.bind(this),
                }
            });
        }

        // control functions can only be used when once the player is ready.
        // don't do anything if the player is not ready
        if (this.isPlayerReady) {
            const state = this.player.getPlayerState();

            // if the player is just in cued state, don't pause it. it will remove
            // the "play" button in the center of the iframe
            if (state !== YT.PlayerState.CUED) {
                this.player[this.action]();
            }
        }
    }

    onPlayerReady(event) {
        this.isPlayerReady = true;
    }

}).register('sb-youtube');

window.addEventListener('WebComponentsReady', function (e) {
    for(let instance of sb.DetailsStorage.instances) {
        instance.$init();
    }
});

